// revision history
// 19\9\25 -> added get for comment in review component by passing it from three pie chart
// 23/9/25 -> from 4 to 5 for reject action added
// 24/9/25 -> from 5 to 4 for reject action added

import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import { FULL_API_BASE_URL } from "../../../Config/Config";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
import NotesIcon from "../../../Assets/Images/CommanImages/grommet-icons_notes.png";
import InfoIcon from "../../../Assets/Images/CommanImages/Informative.png";
import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
import ErrorIcon from "../../../Assets/Images/CommanImages/Error.png";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import ExcludeInput from "../QuestionPaperDetails/ExcludeInput";
import MultiProgress from "../MultiProgressBar/MultiProgress";
import TabComponent from "../QuestionPaperDetails/TabComponent";
import TableDetailsQuesList from "../QuestionPaperDetails/TableDetailsQuesList";
import SectionSelectedDropdown from "../QuestionPaperDetails/SectionSelectedDropdown";
import TableDetailsSelectedQues from "../QuestionPaperDetails/TableDetailsSelectedQuestions";
import DropDownFilterTags from "../QuestionPaperDetails/DropDownFilterTags";
import QuestionTextRenderer from "../QuestionPaperDetails/QuestionTextRenderer";
import ToggleButton from "../../../Components/Shared/ToggleButtons/ToggleButton";
import SlideOutMessageBox from "../../../Components/SlideOutComponent/SlideOutComponent";
import ThreePieChart from "../../../Components/GraphPlain3dComponent/CombinedTriangle";
import TableWith2icons from "../../../Components/TableComponent/TableWith2icons";
import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
import { POST } from "../../../Api/HttpsMethods";
import EndPoints from "../../../Api/EndPoints";
import TableForCommentReviewQuestionPaper from "../../../Components/TableComponent/TableForReviewQuestionPaper";
import ModalForReviewQuestionPaper from "../../../Components/Modals/ModalForReviewQuestionPaper";
import Colors from "../../../Constants/Colors";
function ReviewQuestionPaper({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setNoTimeSet,
  setMessageBoxHeight,
}) {
  // const [seeData , setSeeData] = useState("");

  // console.log("DataClient:", JSON.stringify(dataClient, null, 2));
  const tagFilterRef = useRef(null);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [isOpenSubject, setIsOpenSubject] = useState(true);
  const [isOpenSubjectFilterTags, setIsOpenSubjectFilterTags] = useState(true);
  const [isOpenSingleSelectQues, setIsOpenSingleSelectQues] = useState(false);
  const [isOpenMultiSelectQues, setIsOpenMultiSelectQues] = useState(false);
  const [isOpenFillInBlanckQues, setIsFillInBlanckQues] = useState(false);
  const [isOpenBooleanQues, setIsBooleanQues] = useState(false);
  const [isOpenSectionAQues, setIsOpenSectionAQues] = useState(false);
  const [isOpenSectionBQues, setIsOpenSectionBQues] = useState(false);
  const [isOpenSectionCQues, setIsOpenSectionCQues] = useState(false);
  const [isOpenSectionDQues, setIsOpenSectionDQues] = useState(false);
  const accessToken = localStorage.getItem("other");
  const [accessibleSubjects, setAccessibleSubjects] = useState([]);
  // const userId = dataClient && dataClient.client_schema_name[6][0].user_id;
  const [selectedSections, setSelectedSections] = useState(1);
  const [sectionsTypeID, setSectionsTypeID] = useState(1);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [selectedHeaders, setSelectedHeaders] = useState([]);
  const [reviewComment, setReviewComment] = useState("");

  const [reviewHistory, setReviewHistory] = useState([]);

  // Callback function to receive review history from CombinedTriangle
  const handleReviewHistoryFetched = (fetchedReviewHistory) => {
    console.log(
      "Review history received from CombinedTriangle:",
      fetchedReviewHistory
    );
    setReviewHistory(fetchedReviewHistory);
  };

  const handleCommentChange = (newComment) => {
    console.log("Review comment changed:", newComment);
    // Handle the comment change as needed
  };

  const statusMap = {
    0: "Inactive",
    1: "Assigned",
    2: "Complete",
    3: "Approved",
    4: "Rejected",
    5: "Reopened",
    5: "Deleted",
  };

  const [difficultyCount, setDifficultyCount] = useState({
    easy: 0,
    medium: 0,
    tough: 0,
  });
  const [fixedTopicCountsByType, setFixedTopicCountsByType] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });
  const [fixedTopicEnabledByType, setFixedTopicEnabledByType] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });
  const [showFlagModal, setShowFlagModal] = useState(false);
  const [sectionWiseQuestions, setSectionWiseQuestions] = useState({});
  const [selecteSectionTypeID, setSelecteSectionTypeID] = useState(1);
  const [excludeRepeatCount, setExcludeRepeatCount] = useState(0);
  const [sectionInstructions, setSectionInstructions] = useState({});

  const [reportDashboardData, setReportDashboardData] = useState([]);
  // const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
  // const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  // const clientBranchId =
  //   dataClient?.client_schema_name[6][0].client_branch_id || null;
  // const userId = dataClient?.client_schema_name[6][0].user_id || null;

  const [isReadOnlyMode, setIsReadOnlyMode] = useState(false);
  const toggleAccordionSubjects = () => {
    setIsOpenSubject(!isOpenSubject);
  };
  const toggleAccordionSubjectsFilterTags = () => {
    setIsOpenSubjectFilterTags(!isOpenSubjectFilterTags);
  };
  const toggleAccordionSingleSelectQues = () => {
    setIsOpenSingleSelectQues(!isOpenSingleSelectQues);
  };
  const toggleAccordionMultiSelectQues = () => {
    setIsOpenMultiSelectQues(!isOpenMultiSelectQues);
  };
  const toggleAccordionFillInBlancksQues = () => {
    setIsFillInBlanckQues(!isOpenFillInBlanckQues);
  };
  const toggleAccordionBoolean = () => {
    setIsBooleanQues(!isOpenBooleanQues);
  };
  const toggleAccordionSectionA = () => {
    setIsOpenSectionAQues(!isOpenSectionAQues);
  };
  const toggleAccordionSectionB = () => {
    setIsOpenSectionBQues(!isOpenSectionBQues);
  };
  const toggleAccordionSectionC = () => {
    setIsOpenSectionCQues(!isOpenSectionCQues);
  };
  const toggleAccordionSectionD = () => {
    setIsOpenSectionDQues(!isOpenSectionDQues);
  };
  const questionPaperId = new URLSearchParams(window.location.search).get(
    "MNTQuestionNumbers"
  );

  useEffect(() => {
    if (dataClient) {
      const userName =
        dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
      const clientBranchId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
      const clientId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

      // ADD THIS LINE to capture user_id
      const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id || null;

      // Store values in sessionStorage
      sessionStorage.setItem("user_name", userName);
      sessionStorage.setItem("clientBranchId", clientBranchId);
      sessionStorage.setItem("clientId", clientId);
      sessionStorage.setItem("userId", userId); // Store user_id

      // Log the extracted values
      // console.log("Extracted Data:", {
      //   userName,
      //   userId, // ADD THIS
      //   clientBranchId,
      //   clientId,
      // });
    }
  }, [dataClient]);

  const userName =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
    sessionStorage.getItem("clientBranchId") ||
    null;
  const clientId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
    sessionStorage.getItem("clientId") ||
    null;

  // ADD THIS LINE for user_id
  const userId =
    dataClient?.client_schema_name?.[6]?.[0]?.user_id ||
    sessionStorage.getItem("userId") ||
    null;

  const [draftData, setDraftData] = useState(null);
  const [draftInitialized, setDraftInitialized] = useState(false);
  const [excludeRepeatEdited, setExcludeRepeatEdited] = useState(false);
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [sectionSettingsBySubject, setSectionSettingsBySubject] = useState({});
  const [specialInstructions, setSpecialInstructions] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [version, setVersion] = useState(0);
  const [activeSubjectId, setActiveSubjectId] = useState(null);
  const [enableSingleSlider, setEnableSingleSlider] = useState(false);
  const [enableMultiSlider, setEnableMultiSlider] = useState(false);
  const [enableBooleanSlider, setEnableBooleanSlider] = useState(false);
  const [enableFillSlider, setEnableFillSlider] = useState(false);
  const [sectionDetailsPerSubject, setSectionDetailsPerSubject] = useState({});
  // console.log(activeSubjectId + "activeSubjectId")
  // Add new state for question comments and modal
  const [questionComments, setQuestionComments] = useState({});
  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);

  // Add these state variables after your existing useState declarations
  const [questionViewModalOpen, setQuestionViewModalOpen] = useState(false);
  const [selectedViewQuestionId, setSelectedViewQuestionId] = useState(null);
  const [selectedQuestionData, setSelectedQuestionData] = useState(null);
  const [questionOptionsForView, setQuestionOptionsForView] = useState([]);
  const [selectedQuestionText, setSelectedQuestionText] = useState("");

  // Add handler for Eye icon click (based on preview button logic)
  // In ReviewQuestionPaper component
  // Updated handleEyeIconClick function in ReviewQuestionPaper component
  const handleEyeIconClick = async (questionId) => {
    setSelectedViewQuestionId(questionId);
    setQuestionViewModalOpen(true);

    // Reset states
    setSelectedQuestionText("");
    setSelectedQuestionData(null);
    setQuestionOptionsForView([]);

    try {
      // Call both APIs in parallel for better performance
      const [questionResponse, optionsResponse] = await Promise.all([
        // 1. Get question details from get-questions-by-ids
        fetch(`${FULL_API_BASE_URL}/get-questions-by-ids`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify([questionId]),
        }),

        // 2. Get question options from get-ques-options-by-ques-id-list
        fetch(`${FULL_API_BASE_URL}/get-ques-options-by-ques-id-list`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ques_id_list: [questionId] }),
        }),
      ]);

      // Process question details response
      if (questionResponse.ok) {
        const questionResult = await questionResponse.json();
        const tableData = questionResult?.data?.table_data || [];

        if (tableData.length > 1) {
          const headers = tableData[0].map((h) =>
            h.replace(/^t\*|d\*|n\*/, "")
          );
          const questionRow = tableData[1]; // First data row

          // Find question text column (usually "Question Text")
          const questionTextIndex = headers.findIndex((h) =>
            h.toLowerCase().includes("question text")
          );

          if (questionTextIndex !== -1 && questionRow[questionTextIndex]) {
            setSelectedQuestionText(questionRow[questionTextIndex]);
          }

          console.log("Question details fetched:", questionRow);
        }
      } else {
        console.error("Failed to fetch question details");
      }

      // Process options response
      if (optionsResponse.ok) {
        const optionsResult = await optionsResponse.json();
        const questionData = optionsResult.data?.questions?.[0];

        if (questionData) {
          setSelectedQuestionData(questionData);
          setQuestionOptionsForView(questionData.ques_options || []);
          console.log(
            "Options fetched successfully:",
            questionData.ques_options
          );
        } else {
          console.warn("No question data found for ID:", questionId);
          setSelectedQuestionData(null);
          setQuestionOptionsForView([]);
        }
      } else {
        console.error("Failed to fetch question options");
        setQuestionOptionsForView([]);
      }
    } catch (error) {
      console.error("Error fetching question data:", error);
      setSelectedQuestionText("Error loading question");
      setQuestionOptionsForView([]);
    }
  };

  // Add handler for comment click
  const handleCommentClick = (questionId) => {
    setSelectedQuestionId(questionId);
    setCommentModalOpen(true);
  };

  // Add handler to save question comment
  const handleSaveQuestionComment = (questionId, comment) => {
    setQuestionComments((prev) => ({
      ...prev,
      [questionId]: comment,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      // const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-ques-paper-layout-detail/?ques_paper_id=${questionPaperId}&user_id=${userId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const result = await response.json();
        const questionPaper = result.question_paper;
        setData(questionPaper);
        // logic for num of section and naming pattern auto selected from api
        if (questionPaper?.ques_paper_details?.ques_paper_type === 2) {
          const layoutSubjects = questionPaper.subjects || [];
          const layoutSectionSettings = {};

          layoutSubjects.forEach((subject) => {
            const typeId = subject.section_naming_pattern === "Numeric" ? 2 : 1; // 2 = Numeric, 1 = Alphabetic
            layoutSectionSettings[subject.subject_id] = {
              selectedSections: subject.no_of_sections || 1,
              selecteSectionTypeID: typeId,
              isFixedFromLayout: true,
            };
          });

          // ✅ Save to layout-based sectionSettings
          setSectionSettingsBySubject((prev) => ({
            ...layoutSectionSettings,
            ...prev, // keep draft data if it comes later
          }));
        }
        const specialInstMap = {};
        questionPaper.subjects.forEach((sub) => {
          specialInstMap[sub.subject_id] = sub.special_inst;
        });
        setSpecialInstructions(specialInstMap);

        // Build sectionDetailsPerSubject from questionPaper.all_section_details
        const sectionDetailsMap = {};
        (questionPaper.all_section_details || []).forEach((section) => {
          const { subject_id, section_name } = section;
          if (!sectionDetailsMap[subject_id]) {
            sectionDetailsMap[subject_id] = {};
          }
          sectionDetailsMap[subject_id][section_name] = {
            section_no: section.section_no,
            ms_id: section.ms_id,
            mandatory_ques_cnt: section.mandatory_ques_cnt,
            optional_ques_cnt: section.optional_ques_cnt,
            total_ques_cnt: section.total_ques_cnt,
            instruction: section.section_instructions,
            section_question_type_id: section.section_question_type_id,
          };
        });
        setSectionDetailsPerSubject(sectionDetailsMap);

        // Extract question paper id
        const quesPaperId = questionPaper.ques_paper_details.ques_paper_id;
        // Extract subject IDs (as an array of numbers)
        const subjectIds = questionPaper.subjects.map(
          (subject) => subject.subject_id
        );
        // const assignedCreators = questionPaper.assigned_creators || {};

        // const subjectsWithAccessibility = questionPaper.subjects.map(
        //   (subject) => ({
        //     ...subject,
        //     isAccessible:
        //       assignedCreators[subject.subject_id]?.includes(userId) || false,
        //   })
        // );

        // Replace the existing subjectsWithAccessibility logic with this:
        const reviewers = questionPaper.reviewers || [];

        const subjectsWithAccessibility = questionPaper.subjects.map(
          (subject) => ({
            ...subject,
            isAccessible:
              reviewers.some(
                (reviewer) =>
                  reviewer.subject_id === subject.subject_id &&
                  reviewer.user_id === userId
              ) && [2, 3, 4].includes(subject.subject_status), // Allow status 2, 3, and 4
          })
        );

        setAccessibleSubjects(subjectsWithAccessibility);
        if (!activeSubjectId) {
          const firstAssigned = subjectsWithAccessibility.find(
            (s) => s.isAccessible
          );
          if (firstAssigned) setActiveSubjectId(firstAssigned.subject_id);
        }

        const updatedDifficultyDistributions = {
          single: {},
          multi: {},
          fill: {},
          boolean: {},
        };

        for (const subject of questionPaper.subjects) {
          const chapterIds = subject.chapters?.map((ch) => ch.chapter_id) || [];
          if (chapterIds.length === 0) continue;
          for (const chapterId of chapterIds) {
            // Only assign if the chapter is selected in the subject
            const difficulty = {
              firstSegment: subject.easy || 0,
              secondSegment: subject.medium || 0,
              calculatedValue: subject.tough || 0,
              total:
                (subject.easy || 0) +
                (subject.medium || 0) +
                (subject.tough || 0),
            };
            ["single", "multi", "fill", "boolean"].forEach((type) => {
              if (!updatedDifficultyDistributions[type][chapterId]) {
                updatedDifficultyDistributions[type][chapterId] = difficulty;
              }
            });
          }
        }
        setDifficultyDistributions(updatedDifficultyDistributions);
        const draftApiUrl = new URL(
          `${FULL_API_BASE_URL}/get-ques-paper-by-assignee-draft/`
        );
        draftApiUrl.searchParams.append("ques_paper_id", quesPaperId);
        subjectIds.forEach((id) =>
          draftApiUrl.searchParams.append("subject_ids", id)
        );
        const draftResponse = await fetch(draftApiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        if (!draftResponse.ok) {
          throw new Error("Failed to fetch draft data");
        }
        const draftData = await draftResponse.json();
        setDraftData(draftData);
        // Build difficultyDistributions from draftData
        const updatedDraftDistributions = {
          single: {},
          multi: {},
          fill: {},
          boolean: {},
        };
        const quesTypeMap = {
          1: "single",
          2: "multi",
          3: "fill",
          4: "boolean",
        };
        draftData?.subjects?.forEach((subject) => {
          subject.ques_types?.forEach((qt) => {
            const typeKey = quesTypeMap[qt.ques_type_id];
            if (!typeKey) return;
            qt.chapters?.forEach((chapter) => {
              const chapId = chapter.chapter_id;
              updatedDraftDistributions[typeKey][chapId] = {
                total: chapter.chapter_ques_cnt || 0,
                firstSegment: chapter.easy || 0,
                secondSegment: chapter.medium || 0,
                calculatedValue: chapter.tough || 0,
              };
            });
          });
        });

        setDifficultyDistributions((prev) => ({
          ...prev,
          ...updatedDraftDistributions,
        }));

        const draftSubjectData = draftData?.subjects?.[0]; // Assuming 1 subject for now

        if (draftSubjectData) {
          setSelectedSections(draftSubjectData.no_of_sections || 1);
          setSelectedTemplateId(
            draftSubjectData.ques_paper_user_template_id || null
          );
          setExcludeRepeatCount(draftSubjectData.exclude_repeat_n_times || 0);
          setSelecteSectionTypeID(draftSubjectData.section_naming_type || 1); // If applicable
          setDraftInitialized(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    const timer = setTimeout(() => {
      fetchData();
    }, 500);
    return () => clearTimeout(timer);
  }, [dataClient]);

  useEffect(() => {
    if (!activeSubjectId || !sectionSettingsBySubject[activeSubjectId]) return;
    // Set selected dropdowns only once when activeSubjectId is first available
    setSelectedSections(
      sectionSettingsBySubject[activeSubjectId]?.selectedSections || 1
    );
    setSelecteSectionTypeID(
      sectionSettingsBySubject[activeSubjectId]?.selecteSectionTypeID || 1
    );
  }, [activeSubjectId, sectionSettingsBySubject]);

  const scopeTypeMap = {
    1: "Batch Name",
    2: "Branch Name",
    3: "Zone Name",
    4: "City Name",
    5: "State Name",
    7: "All India",
  };
  const groupedScopes = data?.scopes?.reduce((acc, scope) => {
    if (!acc[scope.scope_id]) {
      acc[scope.scope_id] = [];
    }
    acc[scope.scope_id].push(scope.scope_ref_name);
    return acc;
  }, {});
  const [chapterData, setChapterData] = useState([]);
  const [topicData, setTopicData] = useState({});
  const [checkedChaptersByType, setCheckedChaptersByType] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });
  const [selectedTopicsByType, setSelectedTopicsByType] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });
  const [difficultyDistributions, setDifficultyDistributions] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });
  // const [manualChapterFixedCounts, setManualChapterFixedCounts] = useState({ single: {}, multi: {}, fill: {}, boolean: {}, });
  const isActiveSubjectReadOnly = () => {
    const activeSubjStatus = draftData?.subjects?.find(
      (s) => s.subject_id === activeSubjectId
    )?.status;
    return activeSubjStatus === 2;
  };
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = ""; // Modern browsers require returnValue to be set
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  const handleTabChange = (subjectId, requestedId = null) => {
    const newSubjectId = requestedId ?? subjectId;

    if (hasUnsavedChanges && newSubjectId !== activeSubjectId) {
      setNoTimeSet(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Your changes will be lost before switching the tab. Do you want to
              continue?
            </span>
          </div>
          <div
            className="messagebox-insider2"
            style={{ display: "flex", gap: "10px", marginTop: "10px" }}
          >
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
                setHasUnsavedChanges(false);
                switchTab(newSubjectId);
              }}
            >
              YES
            </button>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
              }}
            >
              NO
            </button>
          </div>
        </div>
      );
      setActiveImg(WarnningIcon);
      setIsMessageBoxVisible(true);
      return;
    }

    // Normal tab switch
    switchTab(newSubjectId);
  };

  const switchTab = async (newSubjectId) => {
    setActiveSubjectId(newSubjectId);

    const settings = sectionSettingsBySubject[newSubjectId] || {};
    setExcludeRepeatCount(settings.excludeRepeatCount || 0);
    setSelectedSections(settings.selectedSections || 1);
    setSelecteSectionTypeID(settings.selecteSectionTypeID || 1);

    try {
      const url = `${FULL_API_BASE_URL}/get-ques-paper-by-assignee-draft/?ques_paper_id=${questionPaperId}&subject_ids=${newSubjectId}`;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) throw new Error("Draft API failed");

      const result = await response.json();
      const draftSubject = result.subjects?.find(
        (sub) => sub.subject_id === newSubjectId
      );
      const tagList = draftSubject?.parse_tags || [];

      // ✅ Normalize into { tag_id, tag_value_id }
      const formattedTags = tagList.map((tag) => ({
        tag_id: tag.parse_tag_id,
        tag_value_id: tag.parse_tag_value_id,
      }));

      // ✅ Save to subject-wise tags
      setSelectedTagsBySubject((prev) => ({
        ...prev,
        [newSubjectId]: formattedTags,
      }));

      // ✅ Set as active subject's selected tags
      setSelectedTags(formattedTags);
    } catch (err) {
      console.error("Error fetching draft tags on tab switch", err);
    }
  };

  useEffect(() => {
    // Once draft is loaded, mark no unsaved changes initially
    if (draftData) {
      setHasUnsavedChanges(false);
    }
  }, [draftData]);

  useEffect(() => {
    if (!activeSubjectId || !draftData?.subjects) return;
    const activeSubjStatus = draftData.subjects.find(
      (s) => s.subject_id === activeSubjectId
    )?.status;
    setIsReadOnlyMode(activeSubjStatus === 2);
  }, [activeSubjectId, draftData]);

  useEffect(() => {
    if (!activeSubjectId) return;
    fetch(
      `${FULL_API_BASE_URL}/get-chapters-by-subject/?subject_id=${activeSubjectId}`
    )
      .then((res) => res.json())
      .then((data) => setChapterData(data || []))
      .catch((err) => console.error("Error fetching chapters:", err));
  }, [activeSubjectId]);

  const handleChapterCheck = (chapterId, type) => {
    console.log(chapterId, type, "chapterId and type from handleChapterCheck");

    setCheckedChaptersByType((prev) => {
      const isChecked = !prev[type][chapterId];
      if (isChecked && !topicData[chapterId]) {
        fetch(
          `${FULL_API_BASE_URL}/get-topics-by-chapter/?chapter_id=${chapterId}`
        )
          .then((response) => response.json())
          .then((data) => {
            setTopicData((prevData) => ({ ...prevData, [chapterId]: data }));

            setSelectedTopicsByType((prevTopics) => ({
              ...prevTopics,
              [type]: {
                ...prevTopics[type],
                [chapterId]: data.map((topic) => topic.topic_id),
              },
            }));
          });
      } else {
        // Update selection
        setSelectedTopicsByType((prevTopics) => ({
          ...prevTopics,
          [type]: {
            ...prevTopics[type],
            [chapterId]: isChecked
              ? topicData[chapterId]?.map((t) => t.topic_id) || []
              : [],
          },
        }));
      }

      return {
        ...prev,
        [type]: {
          ...prev[type],
          [chapterId]: isChecked,
        },
      };
    });
  };

  const [expandedChaptersByType, setExpandedChaptersByType] = useState({
    single: {},
    multi: {},
    fill: {},
    boolean: {},
  });

  const handleChapterExpand = (chapterId, type) => {
    setExpandedChaptersByType((prev) => ({
      ...prev,
      [type]: { ...prev[type], [chapterId]: !prev[type]?.[chapterId] },
    }));
    if (!topicData[chapterId]) {
      fetch(
        `${FULL_API_BASE_URL}/get-topics-by-chapter/?chapter_id=${chapterId}`
      )
        .then((res) => res.json())
        .then((data) => {
          setTopicData((prev) => ({ ...prev, [chapterId]: data }));
        })
        .catch((err) => console.error("Error fetching topics:", err));
    }
  };

  const handleSliderChange = (chapterId, values, type = "single") => {
    setDifficultyDistributions((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [chapterId]: {
          ...prev[type]?.[chapterId],
          ...values,
        },
      },
    }));
  };

  const handleTopicCheck = (chapterId, topicId, type) => {
    const totalTopics = topicData[chapterId]?.map((t) => t.topic_id) || [];
    setSelectedTopicsByType((prev) => {
      const current = prev[type]?.[chapterId] || [];
      const isSelected = current.includes(topicId);
      const updated = isSelected
        ? current.filter((id) => id !== topicId)
        : [...current, topicId];

      // ✅ Also update chapter checked state
      setCheckedChaptersByType((prevChecked) => ({
        ...prevChecked,
        [type]: {
          ...prevChecked[type],
          [chapterId]: updated.length > 0,
        },
      }));

      // ✅ Always keep chapter expanded (so we show "-" even if all topics are unselected)
      setExpandedChaptersByType((prevExpanded) => ({
        ...prevExpanded,
        [type]: {
          ...prevExpanded[type],
          [chapterId]: true,
        },
      }));

      return {
        ...prev,
        [type]: {
          ...prev[type],
          [chapterId]: updated,
        },
      };
    });
  };

  useEffect(() => {
    const types = ["single", "multi", "fill", "boolean"];

    const updatedChecked = {};
    const updatedExpanded = {};

    types.forEach((type) => {
      const currentChecked = { ...checkedChaptersByType[type] };
      const currentExpanded = { ...expandedChaptersByType[type] };
      const selectedTopics = selectedTopicsByType[type] || {};

      Object.entries(selectedTopics).forEach(([chapterId, topicIds]) => {
        const allTopics = topicData[chapterId] || [];
        const isAllUnselected = allTopics.length > 0 && topicIds.length === 0;

        if (isAllUnselected) {
          currentChecked[chapterId] = false;
          currentExpanded[chapterId] = false; // or true, if you want to keep expanded
        }
      });

      updatedChecked[type] = currentChecked;
      updatedExpanded[type] = currentExpanded;
    });

    setCheckedChaptersByType((prev) => ({
      ...prev,
      ...updatedChecked,
    }));

    setExpandedChaptersByType((prev) => ({
      ...prev,
      ...updatedExpanded,
    }));
  }, [selectedTopicsByType, topicData]);

  const handleSelectAllTopics = (chapterId, type) => {
    const allTopics =
      topicData[chapterId]?.map((topic) => topic.topic_id) || [];

    setSelectedTopicsByType((prev) => {
      const alreadySelected = prev[type]?.[chapterId] || [];
      const allSelected = alreadySelected.length === allTopics.length;

      const updated = allSelected ? [] : allTopics;

      // ✅ Sync chapter checked state
      setCheckedChaptersByType((prevChecked) => ({
        ...prevChecked,
        [type]: {
          ...prevChecked[type],
          [chapterId]: updated.length > 0,
        },
      }));

      // ✅ Keep chapter expanded
      setExpandedChaptersByType((prevExpanded) => ({
        ...prevExpanded,
        [type]: {
          ...prevExpanded[type],
          [chapterId]: true,
        },
      }));

      return {
        ...prev,
        [type]: {
          ...prev[type],
          [chapterId]: updated,
        },
      };
    });
  };

  // FOR AUTO SELECTING CHAPTERS AND TOPICS LOGIC
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-ques-paper-layout-detail/?ques_paper_id=${questionPaperId}&user_id=${userId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch data");

        const result = await response.json();
        const paperData = result.question_paper;
        setData(paperData);
        const allSubjectsFromApi = paperData.subjects || [];
        // const assignedCreators = paperData.assigned_creators || {};

        // const subjectsWithAccessibility = paperData.subjects.map((subject) => ({
        //   ...subject,
        //   isAccessible:
        //     assignedCreators[subject.subject_id]?.includes(userId) || false,
        // }));

        // In the second useEffect, replace the subjectsWithAccessibility logic:
        const reviewers = paperData.reviewers || [];

        const subjectsWithAccessibility = paperData.subjects.map((subject) => ({
          ...subject,
          isAccessible:
            reviewers.some(
              (reviewer) =>
                reviewer.subject_id === subject.subject_id &&
                reviewer.user_id === userId
            ) && [2, 3, 4].includes(subject.subject_status), // Allow status 2, 3, and 4
        }));

        setAccessibleSubjects(subjectsWithAccessibility);
        for (const selectedSubject of allSubjectsFromApi) {
          const subjectId = selectedSubject.subject_id;
          const chapterIds = selectedSubject.chapters.map(
            (ch) => ch.chapter_id
          );

          const checked = {};
          const expanded = {};
          const selectedTopics = {};

          for (const chapterId of chapterIds) {
            checked[chapterId] = true;
            expanded[chapterId] = false;

            const topicRes = await fetch(
              `${FULL_API_BASE_URL}/get-topics-by-chapter/?chapter_id=${chapterId}`
            );
            const topicJson = await topicRes.json();

            setTopicData((prev) => ({ ...prev, [chapterId]: topicJson }));
            selectedTopics[chapterId] = topicJson.map((t) => t.topic_id);
          }

          setCheckedChaptersByType((prev) => ({
            ...prev,
            single: { ...prev.single, ...checked },
            multi: { ...prev.multi, ...checked },
            fill: { ...prev.fill, ...checked },
            boolean: { ...prev.boolean, ...checked },
          }));

          setSelectedTopicsByType((prev) => ({
            ...prev,
            single: { ...prev.single, ...selectedTopics },
            multi: { ...prev.multi, ...selectedTopics },
            fill: { ...prev.fill, ...selectedTopics },
            boolean: { ...prev.boolean, ...selectedTopics },
          }));

          setExpandedChaptersByType((prev) => ({
            ...prev,
            single: { ...prev.single, ...expanded },
            multi: { ...prev.multi, ...expanded },
            fill: { ...prev.fill, ...expanded },
            boolean: { ...prev.boolean, ...expanded },
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const timer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  //  Tags
  const [tags, setTags] = useState([]);
  const [selectedTagsBySubject, setSelectedTagsBySubject] = useState({});
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    const hasValidTags = selectedTags.some((tag) => tag.tag_value_id > 0);

    if (hasValidTags) {
      setFinalTags([...selectedTags]);
      setFinalFilters(generateFiltersV2());
    } else {
      setFinalTags([]);
      setFinalFilters([]);
    }
  }, [
    selectedTags,
    checkedChaptersByType,
    selectedTopicsByType,
    activeSubjectId,
  ]);

  const fetchTags = async () => {
    try {
      // const token = sessionStorage.getItem("other");
      const response = await fetch(`${FULL_API_BASE_URL}/get-parse-tags-all/`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      if (response.ok) {
        setTags(data.data);
      } else {
        console.error("Error fetching tags:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  const handleDropdownChange = (tag, selectedOption) => {
    setSelectedTags((prev) => {
      const filtered = prev.filter((item) => item.tag_id !== tag.parse_tag_id);

      if (
        !selectedOption ||
        selectedOption.id === null ||
        selectedOption.id === undefined
      ) {
        setSelectedTagsBySubject((prevSubjects) => ({
          ...prevSubjects,
          [activeSubjectId]: filtered,
        }));
        return filtered;
      }

      const updated = [
        ...filtered,
        {
          tag_id: tag.parse_tag_id,
          tag_value_id: selectedOption.id,
        },
      ];

      setSelectedTagsBySubject((prevSubjects) => ({
        ...prevSubjects,
        [activeSubjectId]: updated,
      }));

      setHasUnsavedChanges(true); // ✅ track unsaved
      return updated;
    });
  };

  const handleCheckboxChange = (tag, checked) => {
    setSelectedTags((prev) => {
      const filtered = prev.filter((item) => item.tag_id !== tag.parse_tag_id);
      const updated = [
        ...filtered,
        {
          tag_id: tag.parse_tag_id,
          tag_value_id: checked ? 1 : 0,
        },
      ];

      setSelectedTagsBySubject((prevSubjects) => ({
        ...prevSubjects,
        [activeSubjectId]: updated,
      }));

      setHasUnsavedChanges(true); // ✅ track unsaved
      return updated;
    });
  };

  const [questionFilters, setQuestionFilters] = useState([]);

  const generateFilters = (quesTypeId = 1) => {
    if (!data) return [];

    const courseId = data?.ques_paper_details?.course_id || 0;

    const filters = Object.keys(checkedChaptersByType)
      .filter((chapterId) => checkedChaptersByType[chapterId])
      .map((chapterId) => {
        const topicIds = selectedTopicsByType[chapterId] || [];

        return {
          subject_id: data?.subjects?.[0]?.subject_id, // Update if you handle more subjects
          course_id: courseId,
          chapter_id: [parseInt(chapterId)],
          topic_id: topicIds,
          ques_type_id: [quesTypeId], // e.g. 1 = Single Select
        };
      });

    return filters;
  };

  const scopeRefIds = data?.scopes?.map((scope) => scope.scope_ref_id) || [0];

  const generateFiltersV2 = () => {
    if (!data || !activeSubjectId) return [];

    const activeSubject = data.subjects.find(
      (subj) => subj.subject_id === activeSubjectId
    );
    const courseId = data.ques_paper_details?.course_id || 0;
    const validChapterIds = new Set(
      activeSubject?.chapters?.map((ch) => ch.chapter_id) || []
    );
    const activeQuesTypes =
      data.ques_paper_details?.parse_ques_set_ques_type || [];

    const quesTypes = activeQuesTypes
      .map((quesTypeId) => {
        let typeKey = "";
        switch (quesTypeId) {
          case 1:
            typeKey = "single";
            break;
          case 2:
            typeKey = "multi";
            break;
          case 3:
            typeKey = "fill";
            break;
          case 4:
            typeKey = "boolean";
            break;
          default:
            return null;
        }

        const chaptersObj = checkedChaptersByType[typeKey] || {};
        const topicsObj = selectedTopicsByType[typeKey] || {};

        const filteredChapters = Object.entries(chaptersObj)
          .filter(
            ([chapterId, isChecked]) =>
              isChecked && validChapterIds.has(parseInt(chapterId))
          )
          .map(([chapterId]) => ({
            chapter_id: parseInt(chapterId),
            topics: topicsObj[chapterId] || [],
          }));

        return {
          ques_type_id: quesTypeId,
          chapters:
            filteredChapters.length > 0
              ? filteredChapters
              : [
                  {
                    chapter_id: 0,
                    topics: [0],
                  },
                ],
        };
      })
      .filter(Boolean);

    return [
      {
        ques_types: quesTypes,
      },
    ];
  };

  useEffect(() => {
    const filters = generateFilters(1); // or whatever ques_type_id is active
    setQuestionFilters(filters);
  }, [checkedChaptersByType, selectedTopicsByType, data]); // Add dependencies as needed

  const [finalTags, setFinalTags] = useState([]);
  const [finalFilters, setFinalFilters] = useState([]);
  const memoizedTags = useMemo(
    () => selectedTags,
    [JSON.stringify(selectedTags)]
  );
  const memoizedFilters = useMemo(
    () => finalFilters,
    [JSON.stringify(finalFilters)]
  );

  // Auto-generate filters when tags or chapter/topic selections change
  useEffect(() => {
    const hasValidTags = selectedTags.some((tag) => tag.tag_value_id > 0);
    if (hasValidTags) {
      setFinalTags([...selectedTags]);
      setFinalFilters(generateFiltersV2()); // uses activeSubjectId & tag logic
    } else {
      setFinalTags([]);
      setFinalFilters([]);
    }
  }, [
    selectedTags,
    checkedChaptersByType,
    selectedTopicsByType,
    activeSubjectId,
  ]);

  const totalChapterQuestionCount = Object.entries(
    difficultyDistributions
  ).reduce((acc, [chapterId, dist]) => {
    if (checkedChaptersByType[chapterId]) {
      return acc + (dist.total || 0);
    }
    return acc;
  }, 0);

  const activeSubject = accessibleSubjects.find(
    (subj) => subj.subject_id === activeSubjectId
  );
  const easyCount = difficultyCount.easy || 0;
  const mediumCount = difficultyCount.medium || 0;
  const toughCount = difficultyCount.tough || 0;
  const totaldiff = easyCount + mediumCount + toughCount;
  const maxBarHeight = 180;
  const maxValue = Math.max(
    activeSubject?.easy || 0,
    activeSubject?.medium || 0,
    activeSubject?.tough || 0,
    1
  );
  const overallRecommended =
    (activeSubject?.easy || 0) +
    (activeSubject?.medium || 0) +
    (activeSubject?.tough || 0);
  const unitHeight = maxBarHeight / maxValue;
  const recommendedEasy = activeSubject?.easy || 0;
  const recommendedMedium = activeSubject?.medium || 0;
  const recommendedTough = activeSubject?.tough || 0;
  const easyBarHeight = recommendedEasy * unitHeight;
  const mediumBarHeight = recommendedMedium * unitHeight;
  const toughBarHeight = recommendedTough * unitHeight;
  const cappedEasyCount = Math.min(easyCount, recommendedEasy);
  // const easyFillHeight = cappedEasyCount * unitHeight;
  const maxFillVisualHeight = 210;
  const easyFillHeight = Math.min(easyCount * unitHeight, maxFillVisualHeight);
  const mediumFillHeight = Math.min(
    mediumCount * unitHeight,
    maxFillVisualHeight
  );
  const cappedMediumCount = Math.min(mediumCount, recommendedMedium);
  // const mediumFillHeight = cappedMediumCount * unitHeight;
  const cappedToughCount = Math.min(toughCount, recommendedTough);
  // const toughFillHeight = cappedToughCount * unitHeight;
  const toughFillHeight = Math.min(
    toughCount * unitHeight,
    maxFillVisualHeight
  );
  const easyBottom = `${easyFillHeight + 22}px`;
  const mediumBottom = `${mediumFillHeight + 22}px`;
  const toughBottom = `${toughFillHeight + 22}px`;
  const allRecommendedZero =
    (activeSubject?.easy || 0) === 0 &&
    (activeSubject?.medium || 0) === 0 &&
    (activeSubject?.tough || 0) === 0;
  const overallRecommendedCount =
    (activeSubject?.easy || 0) +
    (activeSubject?.medium || 0) +
    (activeSubject?.tough || 0);
  const cappedOverallCount =
    cappedEasyCount + cappedMediumCount + cappedToughCount;
  const overallFillPercent =
    overallRecommendedCount > 0
      ? Math.min((cappedOverallCount / overallRecommendedCount) * 100, 100)
      : 0;
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [templateData, setTemplateData] = useState([]);

  useEffect(() => {
    const fetchTemplates = async () => {
      if (!activeSubjectId || isNaN(activeSubjectId)) {
        console.warn("Invalid or missing subject ID. Skipping fetch.");
        return;
      }

      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-subject-template-list-by-user/?username=${userName}&client_branch_id=${clientBranchId}&subject_id=${activeSubjectId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        const result = await response.json();
        setTemplateData(result?.data?.template_list || []);
      } catch (error) {
        console.error("Error fetching templates:", error);
      }
    };
    fetchTemplates();
  }, [activeSubjectId]);

  useEffect(() => {
    if (
      selectedTemplateId === null ||
      selectedTemplateId === "" ||
      selectedTemplateId === undefined
    ) {
      setTemplateDetailData(null);
      setSelectedTags([]);
      setFinalTags([]); // Clear tags from memoized filters
      setFinalFilters([]); // ✅ Explicitly clear filters here

      // Also reset chapter/topic selections
      setCheckedChaptersByType({
        single: {},
        multi: {},
        fill: {},
        boolean: {},
      });
      setSelectedTopicsByType({ single: {}, multi: {}, fill: {}, boolean: {} });
      setExpandedChaptersByType({
        single: {},
        multi: {},
        fill: {},
        boolean: {},
      });

      // Reset any fixed topic counts
      setFixedTopicCountsByType({
        single: {},
        multi: {},
        fill: {},
        boolean: {},
      });
      setFixedTopicEnabledByType({
        single: {},
        multi: {},
        fill: {},
        boolean: {},
      });
    }
  }, [selectedTemplateId]);

  const handleSectionInstructionChange = (sectionLabel, value) => {
    setSectionInstructions((prev) => ({
      ...prev,
      [sectionLabel]: value,
    }));
  };

  const [showTemplatePopup, setShowTemplatePopup] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [templateDesc, setTemplateDesc] = useState("");
  const [templateNameError, setTemplateNameError] = useState(false);
  const [templateDescError, setTemplateDescError] = useState(false);
  const [templatePopupError, setTemplatePopupError] = useState("");

  const handleSaveQuestionPaper = async (status = 2) => {
    if (!data) return;
    // Validation function (only run for Final save)
    const validateBeforeSave = () => {
      const recommendedEasy = activeSubject?.easy || 0;
      const recommendedMedium = activeSubject?.medium || 0;
      const recommendedTough = activeSubject?.tough || 0;
      const selectedEasy = difficultyCount.easy || 0;
      const selectedMedium = difficultyCount.medium || 0;
      const selectedTough = difficultyCount.tough || 0;

      if (selectedEasy !== recommendedEasy) {
        return `Easy question count must be exactly ${recommendedEasy}. You have selected ${selectedEasy}.`;
      }

      if (selectedMedium !== recommendedMedium) {
        return `Medium question count must be exactly ${recommendedMedium}. You have selected ${selectedMedium}.`;
      }

      if (selectedTough !== recommendedTough) {
        return `Tough question count must be exactly ${recommendedTough}. You have selected ${selectedTough}.`;
      }

      const localSelectedRowIds = JSON.parse(
        localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
      );
      const localSectionMap = JSON.parse(
        localStorage.getItem("subjectWiseSectionMap") || "{}"
      );

      const selectedIds = localSelectedRowIds[activeSubjectId] || [];
      const sectionMap = localSectionMap[activeSubjectId] || {};

      const unassignedIds = selectedIds.filter((id) => !sectionMap[id]);

      if (unassignedIds.length > 0) {
        return `${unassignedIds.length} question(s) do not have a section assigned.`;
      }

      if (selectedSections > 1) {
        for (let i = 0; i < selectedSections; i++) {
          const sectionLabel =
            selecteSectionTypeID === 2
              ? `${i + 1}`
              : String.fromCharCode(65 + i);
          const countInSection =
            sectionWiseQuestions[sectionLabel]?.length || 0;
          if (countInSection === 0) {
            return `Section ${sectionLabel} has no questions selected.`;
          }
        }
      }

      for (const [type, chapters] of Object.entries(fixedTopicEnabledByType)) {
        for (const [chapId, isEnabled] of Object.entries(chapters)) {
          if (isEnabled) {
            const topics = fixedTopicCountsByType[type][chapId];
            for (const [topicId, fixedCount] of Object.entries(topics)) {
              const actualCount = selectedQuestions.filter(
                (q) => q.topic_id === parseInt(topicId)
              ).length;
              if (actualCount !== fixedCount) {
                return `Topic ${topicId} fixed count mismatch (Fixed: ${fixedCount}, Selected: ${actualCount}).`;
              }
            }
          }
        }
      }

      const chapterCounts = {};
      const topicCounts = {};

      selectedQuestions.forEach((q) => {
        chapterCounts[q.chapter_id] = (chapterCounts[q.chapter_id] || 0) + 1;
        topicCounts[q.topic_id] = (topicCounts[q.topic_id] || 0) + 1;
      });

      const totalChapterCount = Object.values(chapterCounts).reduce(
        (a, b) => a + b,
        0
      );
      const totalTopicCount = Object.values(topicCounts).reduce(
        (a, b) => a + b,
        0
      );

      if (totalChapterCount !== totalTopicCount) {
        return `Total chapter count (${totalChapterCount}) does not match total topic count (${totalTopicCount}).`;
      }

      if (selectedSections > 0) {
        const localQuesTypeMap =
          JSON.parse(localStorage.getItem("subjectWiseQuesTypeIds") || "{}")[
            activeSubjectId
          ] || {};

        for (let i = 0; i < selectedSections; i++) {
          const sectionLabel =
            selecteSectionTypeID === 2
              ? `${i + 1}`
              : String.fromCharCode(65 + i);
          const sectionKey = `Section ${sectionLabel}`;
          const questionsInSection = sectionWiseQuestions[sectionLabel] || [];

          const sectionData =
            sectionDetailsPerSubject?.[activeSubjectId]?.[sectionKey];
          const expectedTypeId = sectionData?.section_question_type_id;

          if (!expectedTypeId) continue;

          const mismatchedQuesIds = questionsInSection
            .map((question) => {
              const qid =
                question.id ||
                question.ques_id ||
                question.parse_ques_set_question_id;
              const actualTypeId = parseInt(localQuesTypeMap[qid]);
              return actualTypeId !== expectedTypeId ? qid : null;
            })
            .filter(Boolean); // remove nulls

          if (mismatchedQuesIds.length > 0) {
            const readableType = questionTypeMap[expectedTypeId] || "Unknown";
            return `Only "${readableType}" type questions are permitted in Section ${sectionLabel} for this test series. Please check the Question Type column and update the section.`;
          }
        }
      }

      // HANDLE SECTION QUESTION COUNT ERRORS
      if (selectedSections > 1) {
        for (let i = 0; i < selectedSections; i++) {
          const sectionLabel =
            selecteSectionTypeID === 2
              ? `${i + 1}`
              : String.fromCharCode(65 + i);
          const sectionKey = `Section ${sectionLabel}`;
          const sectionData =
            sectionDetailsPerSubject?.[activeSubjectId]?.[sectionKey];
          const questionsInSection = sectionWiseQuestions[sectionLabel] || [];

          const totalExpected = sectionData?.total_ques_cnt ?? 0;

          if (questionsInSection.length !== totalExpected) {
            return `Section ${sectionLabel}: Selected ${questionsInSection.length} of ${totalExpected} questions.`;
          }
        }
      }

      return null;
    };

    // 🛑 Run validation only if FINAL SAVE (status 2)
    if (status === 2) {
      const error = validateBeforeSave();
      if (error) {
        setMessageBox(
          <div>
            <p style={{ margin: "4px 0" }}>{error}</p>
          </div>
        );
        setActiveImg(ErrorIcon);
        setIsMessageBoxVisible(true);
        return; // ❌ Stop if error found
      }
      const localSelectedRowIds = JSON.parse(
        localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
      );
      const localSectionMap = JSON.parse(
        localStorage.getItem("subjectWiseSectionMap") || "{}"
      );

      const selectedIds = localSelectedRowIds[activeSubjectId] || [];
      const sectionMap = localSectionMap[activeSubjectId] || {};

      const unassignedIds = selectedIds.filter((id) => !sectionMap[id]);

      if (unassignedIds.length > 0) {
        setMessageBox(
          <div>
            <p>{`${unassignedIds.length} question(s) do not have a section assigned.`}</p>
          </div>
        );
        setActiveImg(ErrorIcon);
        setIsMessageBoxVisible(true);
        return; // Stop save
      }
    }

    // ✅ After here = Save logic for both Draft and Final
    let questionsPayload = [];
    const quesTypeMapping = {
      "Single Correct MCQ": 1,
      "Multi Correct MCQ": 2,
      "Fill in the blanks": 3,
      "True/False": 4,
    };

    if (status === 1) {
      const subjectWise = JSON.parse(
        localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
      );
      const quesTypeLocal = JSON.parse(
        localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
      );
      const deletedData = JSON.parse(
        localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
      );

      const selectedIdsArray = subjectWise[activeSubjectId] || [];
      const selectedIdsSet = new Set(selectedIdsArray);
      const localTypeMap = quesTypeLocal[activeSubjectId] || {};
      const deletedIdsArray = deletedData[activeSubjectId] || [];

      const allQuesMap = new Map();

      // Step 1️⃣: Add selected questions from localStorage with status 1
      selectedIdsArray.forEach((quesId, index) => {
        const matchedRow = reportDashboardData.find((row) => row[1] === quesId); // row[1] = Ques ID
        const quesTypeText = matchedRow?.[3]; // row[3] = Ques Type string
        const fallbackQuesTypeId = quesTypeMapping[quesTypeText] || null;
        const quesTypeId = localTypeMap[quesId] || fallbackQuesTypeId;

        let sectionName = null;
        for (const [sectionLabel, questions] of Object.entries(
          sectionWiseQuestions
        )) {
          if (
            questions.find(
              (q) => q.id === quesId || q.parse_ques_set_question_id === quesId
            )
          ) {
            sectionName = sectionLabel;
            break;
          }
        }

        allQuesMap.set(quesId, {
          parse_ques_set_question_id: quesId,
          org_ques_position: index + 1,
          status: 1,
          section_name: sectionName,
          ques_type_id: quesTypeId,
          added_by: userName,
          removed_by: userName,
        });
      });

      // Step 2️⃣: Add non-selected questions from reportDashboardData with status 0
      reportDashboardData.forEach((row, index) => {
        const quesId = row[0];
        if (allQuesMap.has(quesId)) return;

        const quesTypeText = row[2]; // Question type
        const fallbackQuesTypeId = quesTypeMapping[quesTypeText] || null;

        allQuesMap.set(quesId, {
          parse_ques_set_question_id: quesId,
          org_ques_position: index + 1,
          status: 0,
          section_name: null,
          ques_type_id: fallbackQuesTypeId,
          added_by: userName,
          removed_by: userName,
        });
      });

      // Step 3️⃣: Add missing deleted question IDs with status 2
      deletedIdsArray.forEach((quesId, index) => {
        if (!allQuesMap.has(quesId)) {
          const quesTypeId = localTypeMap[quesId] || null;

          allQuesMap.set(quesId, {
            parse_ques_set_question_id: quesId,
            org_ques_position: selectedIdsArray.length + index + 1,
            status: 2,
            section_name: null,
            ques_type_id: 0,
            added_by: userName,
            removed_by: userName,
          });
        } else {
          const existing = allQuesMap.get(quesId);
          existing.status = 2; // Override if already added
        }
      });
      questionsPayload = Array.from(allQuesMap.values());
    } else {
      const subjectWise = JSON.parse(
        localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
      );
      const quesTypeLocal = JSON.parse(
        localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
      );
      const deletedData = JSON.parse(
        localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
      );

      const selectedIds = subjectWise[activeSubjectId] || [];
      const localTypeMap = quesTypeLocal[activeSubjectId] || {};
      const deletedIdsArray = deletedData[activeSubjectId] || [];

      const allQuesMap = new Map();

      // ✅ Step 1: Selected questions with status 1
      selectedIds.forEach((quesId, index) => {
        const quesTypeStr = localTypeMap[quesId] || "Single Correct MCQ"; // fallback
        const quesTypeId = quesTypeMapping[quesTypeStr] || 1;

        let sectionName = null;
        for (const [sectionLabel, questions] of Object.entries(
          sectionWiseQuestions
        )) {
          if (
            questions.find(
              (q) => q.id === quesId || q.parse_ques_set_question_id === quesId
            )
          ) {
            sectionName = sectionLabel;
            break;
          }
        }

        allQuesMap.set(quesId, {
          parse_ques_set_question_id: quesId,
          org_ques_position: index + 1,
          status: 1,
          section_name: sectionName,
          ques_type_id: quesTypeId,
          added_by: userName,
          removed_by: userName,
        });
      });

      // ✅ Step 2: Deleted questions with status 2
      deletedIdsArray.forEach((quesId, index) => {
        if (!allQuesMap.has(quesId)) {
          const quesTypeStr = localTypeMap[quesId] || "Single Correct MCQ";
          const quesTypeId = quesTypeMapping[quesTypeStr] || 1;

          allQuesMap.set(quesId, {
            parse_ques_set_question_id: quesId,
            org_ques_position: selectedIds.length + index + 1,
            status: 2,
            section_name: null,
            ques_type_id: quesTypeId,
            added_by: userName,
            removed_by: userName,
          });
        } else {
          const existing = allQuesMap.get(quesId);
          existing.status = 2; // overwrite status
        }
      });
      questionsPayload = Array.from(allQuesMap.values());
    }
    const activeQuesTypeIds =
      data?.ques_paper_details?.parse_ques_set_ques_type || [];
    const payload = {
      ques_paper_id: parseInt(questionPaperId),
      subjects: accessibleSubjects
        .filter(
          (subject) =>
            subject.subject_id === activeSubjectId && subject.isAccessible
        )
        .map((subject, index) => {
          const subjectId = subject.subject_id;
          const subjectChapterIds = new Set(
            subject.chapters.map((c) => c.chapter_id)
          );
          // ✅ Use subject-specific section settings
          const settings = sectionSettingsBySubject[subjectId] || {};
          const selectedSectionsLocal = settings.selectedSections || 1;
          const excludeRepeatCountLocal = settings.excludeRepeatCount || 0;
          const sectionTypeLocal = settings.selecteSectionTypeID || 1;
          const ques_types = activeQuesTypeIds.map((ques_type_id) => {
            const typeKey =
              ques_type_id === 1
                ? "single"
                : ques_type_id === 2
                ? "multi"
                : ques_type_id === 3
                ? "fill"
                : "boolean";
            const chaptersObj = checkedChaptersByType[typeKey] || {};
            const topicsObj = selectedTopicsByType[typeKey] || {};
            const fixedCounts = fixedTopicCountsByType[typeKey] || {};
            const difficulty = difficultyDistributions[typeKey] || {};
            const chapters = Object.entries(chaptersObj)
              .filter(
                ([chapterId, isChecked]) =>
                  isChecked && subjectChapterIds.has(parseInt(chapterId))
              )
              .map(([chapterId]) => {
                const chapterIdNum = parseInt(chapterId);
                const selectedTopics = topicsObj[chapterId] || [];
                return {
                  chapter_id: chapterIdNum,
                  chapter_ques_cnt: difficulty[chapterId]?.total || 0,
                  easy: difficulty[chapterId]?.firstSegment || 0,
                  medium: difficulty[chapterId]?.secondSegment || 0,
                  tough: difficulty[chapterId]?.calculatedValue || 0,
                  topic: selectedTopics.map((tid) => ({
                    topic_id: tid,
                    topic_fix_ques_cnt: fixedCounts?.[chapterId]?.[tid] || 0,
                  })),
                };
              });

            return {
              ques_type_id,
              chapters,
            };
          });
          const getSubjectPosition = (subjectId) => {
            const position = data.subjects.findIndex(
              (subj) => subj.subject_id === subjectId
            );
            return position >= 0 ? position + 1 : null; // add 1 to make it 1-based index
          };
          return {
            subject_id: subjectId,
            no_of_sections: selectedSectionsLocal,
            exclude_repeat_n_times: excludeRepeatCountLocal,
            ques_paper_user_template_id: selectedTemplateId,
            status,
            user_name: userName,
            org_subject_position: getSubjectPosition(subjectId),
            ques_types,
            parse_tags: (selectedTagsBySubject[subjectId] || [])
              .filter(
                (tag) =>
                  tag.tag_value_id !== null && tag.tag_value_id !== undefined
              )
              .map((tag) => ({
                parse_tag_id: tag.tag_id,
                parse_tag_value_id: tag.tag_value_id,
              })),
            sections: [...Array(selectedSectionsLocal)].map((_, secIndex) => {
              const sectionLabel =
                sectionTypeLocal === 2
                  ? `${secIndex + 1}`
                  : String.fromCharCode(65 + secIndex);
              return {
                section_name: sectionLabel,
                section_instruction: sectionInstructions[sectionLabel] || "",
              };
            }),
            questions: questionsPayload,
          };
        }),
    };

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/create-ques-paper-by-assignee/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      if (response.ok) {
        if (status === 2) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>
                  Question paper submitted successfully. Do you want to save
                  this as a template?
                </span>
              </div>
              <div
                className="messagebox-insider2"
                style={{ display: "flex", gap: "10px", marginTop: "10px" }}
              >
                <button
                  className="messagebox-cancel-btn-ok"
                  onClick={() => {
                    setIsMessageBoxVisible(false);
                    setShowTemplatePopup(true);
                  }}
                >
                  YES
                </button>
                <button
                  className="messagebox-cancel-btn-ok"
                  onClick={() => {
                    setIsMessageBoxVisible(false);
                    localStorage.removeItem("subjectWiseSelectedRowIds");
                    localStorage.removeItem("subjectWiseDeletedRowIds");
                    localStorage.removeItem("subjectWiseQuesTypeIds");
                    localStorage.removeItem("subjectWiseSectionMap");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                    navigate("/DashboardCreateQuestionpaper");
                  }}
                >
                  NO
                </button>
              </div>
            </div>
          );
          setActiveImg(InfoIcon);
          setIsMessageBoxVisible(true);
        } else {
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Question paper saved as draft!</span>
              </div>
            </div>
          );
          setActiveImg(InfoIcon);
          setHasUnsavedChanges(false);
          setNoTimeSet(false);
        }
        // localStorage.removeItem("selectedRowIds");
        const subjectWise = JSON.parse(
          localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
        );
        // delete subjectWise[activeSubjectId];
        localStorage.setItem(
          "subjectWiseSelectedRowIds",
          JSON.stringify(subjectWise)
        );
        // localStorage.removeItem("subjectWiseDeletedRowIds");
      }
    } catch (error) {
      console.error("Error while saving:", error);
      setMessageBox("Something went wrong while saving.");
      setIsMessageBoxVisible(true);
    }
  };

  const handleCreateTemplate = async () => {
    const isNameEmpty = !templateName.trim();
    const isDescEmpty = !templateDesc.trim();
    setTemplateNameError(isNameEmpty);
    setTemplateDescError(isDescEmpty);
    if (isNameEmpty || isDescEmpty) return;

    try {
      const encodedName = encodeURIComponent(templateName);
      const encodedDesc = encodeURIComponent(templateDesc);
      const templateURL = `${FULL_API_BASE_URL}/create-subject-template-by-user/?ques_paper_id=${questionPaperId}&question_paper_subject_id=${activeSubjectId}&ques_paper_subject_template_name=${encodedName}&ques_paper_subject_template_desc=${encodedDesc}&client_branch_id=${clientBranchId}&username=${userName}`;

      const response = await fetch(templateURL, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.status === 200) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Template created successfully!</span>
            </div>
          </div>
        );
        setShowTemplatePopup(false);
        // 🔽 Remove localStorage items
        localStorage.removeItem("subjectWiseSelectedRowIds");
        localStorage.removeItem("subjectWiseDeletedRowIds");
        localStorage.removeItem("subjectWiseQuesTypeIds");
        localStorage.removeItem("subjectWiseSectionMap");

        setTimeout(() => window.location.reload(), 1000);
      } else if (
        result.status === 404 &&
        result.message?.toLowerCase().includes("already exists")
      ) {
        setTemplatePopupError(result.message);
      } else {
        throw new Error(result.message || "Unexpected error");
      }
    } catch (error) {
      console.error("Template creation failed:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{error.message || "Failed to create template"}</span>
          </div>
        </div>
      );
      setActiveImg(InfoIcon);
    }
  };

  const [templateDetailData, setTemplateDetailData] = useState(null);

  useEffect(() => {
    const fetchTemplateDetails = async () => {
      if (!selectedTemplateId) return;
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-subject-template-details-by-template-id?ques_paper_subject_template_id=${selectedTemplateId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const result = await response.json();
        const submittedStatus =
          draftData?.subjects?.find(
            (subj) => subj.subject_id === activeSubjectId
          )?.status === 2;
        if (
          (!response.ok || !result?.data?.subjects?.length) &&
          !submittedStatus
        ) {
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>
                  No data found in the selected template. Please choose a
                  different template.
                </span>
              </div>
            </div>
          );
          setActiveImg(WarnningIcon);
          return;
        }
        const templateData = result?.data;

        if (templateData) {
          setTemplateDetailData(result);

          // ✅ Sections & repeat count
          if (!draftInitialized) {
            setSelectedSections(templateData.no_of_sections || 1);
            if (!excludeRepeatEdited) {
              setExcludeRepeatCount(templateData.exclude_repeat_n_times || 0);
            }
          }

          // ✅ Tags
          if (templateData.subjects?.[0]?.tags) {
            const formattedTags = templateData.subjects[0].tags.map((tag) => ({
              tag_id: tag.parse_tag_id,
              tag_value_id: tag.parse_tag_value_id,
            }));
            setSelectedTags(formattedTags);
          }

          // ✅ Chapters/Topics per question type
          const updatedChecked = {
            single: {},
            multi: {},
            fill: {},
            boolean: {},
          };
          const updatedExpanded = {
            single: {},
            multi: {},
            fill: {},
            boolean: {},
          };
          const updatedTopics = {
            single: {},
            multi: {},
            fill: {},
            boolean: {},
          };
          const updatedFixed = { single: {}, multi: {}, fill: {}, boolean: {} };
          const fixedEnabled = { single: {}, multi: {}, fill: {}, boolean: {} };

          const quesTypeMap = {
            1: "single",
            2: "multi",
            3: "fill",
            4: "boolean",
          };

          for (const quesTypeData of templateData.subjects[0]
            ?.chapter_topic_structure || []) {
            const typeKey = quesTypeMap[quesTypeData.parse_ques_set_ques_type];
            if (!typeKey) continue;

            for (const chapter of quesTypeData.chapters || []) {
              const chapId = chapter.chapter_id;
              updatedChecked[typeKey][chapId] = true;
              updatedExpanded[typeKey][chapId] = true;

              const topicIds = chapter.topics?.map((t) => t.topic_id) || [];
              updatedTopics[typeKey][chapId] = topicIds;

              const fixedMap = {};
              let anyFixed = false;

              chapter.topics?.forEach((t) => {
                if (t.topic_ques_cnt > 0) {
                  fixedMap[t.topic_id] = t.topic_ques_cnt;
                  anyFixed = true;
                }
              });

              if (anyFixed) {
                updatedFixed[typeKey][chapId] = fixedMap;
                fixedEnabled[typeKey][chapId] = true;
              }
            }
          }

          // ✅ Update all the states
          setCheckedChaptersByType((prev) => ({ ...prev, ...updatedChecked }));
          setExpandedChaptersByType((prev) => ({
            ...prev,
            ...updatedExpanded,
          }));
          setSelectedTopicsByType((prev) => ({ ...prev, ...updatedTopics }));
          setFixedTopicCountsByType((prev) => ({ ...prev, ...updatedFixed }));
          setFixedTopicEnabledByType((prev) => ({ ...prev, ...fixedEnabled }));
        }
      } catch (error) {
        console.error("Error fetching template details:", error);
      }
    };
    fetchTemplateDetails();
  }, [selectedTemplateId, draftInitialized, excludeRepeatEdited]);

  useEffect(() => {
    if (draftData && draftData.subjects?.length > 0) {
      const firstSubject = draftData.subjects[0];

      if (typeof firstSubject.no_of_sections === "number") {
        setSectionsTypeID(firstSubject.no_of_sections);
        setSelectedSections(firstSubject.no_of_sections);
      }

      // ✅ Insert the following here:
      const draftSectionSettings = {};
      draftData.subjects.forEach((subject) => {
        draftSectionSettings[subject.subject_id] = {
          selectedSections: subject.no_of_sections ?? 1,
          excludeRepeatCount: subject.exclude_repeat_n_times ?? 0,
          selecteSectionTypeID:
            subject.section_naming_type !== undefined
              ? subject.section_naming_type
              : sectionSettingsBySubject[subject.subject_id]
                  ?.selecteSectionTypeID ?? 1,
        };
      });

      setSectionSettingsBySubject((prev) => ({
        ...prev,
        ...draftSectionSettings,
      }));

      // ✅ Then your existing tag logic (if any) can follow
      const tagsBySubject = {};
      draftData.subjects.forEach((subject) => {
        if (subject.parse_tags?.length > 0) {
          tagsBySubject[subject.subject_id] = subject.parse_tags.map((tag) => ({
            tag_id: tag.parse_tag_id,
            tag_value_id: tag.parse_tag_value_id,
          }));
        }
      });
      setSelectedTagsBySubject(tagsBySubject);

      if (activeSubjectId) {
        setSelectedTags(tagsBySubject[activeSubjectId] || []);
      } else {
        setSelectedTags(tagsBySubject[firstSubject.subject_id] || []);
      }
    }
  }, [draftData, activeSubjectId]);

  useEffect(() => {
    if (!draftData || !topicData || !data) return;

    const draftSubjects = draftData.subjects || [];
    const layoutSubjects = data.subjects || [];

    // ✅ Use only draft data if available
    if (draftSubjects.length === 0) return;

    const quesTypeMap = {
      1: "single",
      2: "multi",
      3: "fill",
      4: "boolean",
    };

    const updatedChecked = { single: {}, multi: {}, fill: {}, boolean: {} };
    const updatedExpanded = { single: {}, multi: {}, fill: {}, boolean: {} };
    const updatedTopics = { single: {}, multi: {}, fill: {}, boolean: {} };
    const updatedFixed = { single: {}, multi: {}, fill: {}, boolean: {} };
    const fixedEnabled = { single: {}, multi: {}, fill: {}, boolean: {} };

    draftSubjects.forEach((subject) => {
      subject.ques_types.forEach((qt) => {
        const typeKey = quesTypeMap[qt.ques_type_id];
        if (!typeKey) return;

        qt.chapters.forEach((chapter) => {
          const chapId = chapter.chapter_id;
          updatedChecked[typeKey][chapId] = true;
          updatedExpanded[typeKey][chapId] = true;

          const topicIds = chapter.topic.map((t) => t.topic_id);
          updatedTopics[typeKey][chapId] = topicIds;

          const fixedMap = {};
          let anyFixed = false;

          chapter.topic.forEach((t) => {
            if (t.topic_fix_ques_cnt > 0) {
              fixedMap[t.topic_id] = t.topic_fix_ques_cnt;
              anyFixed = true;
            }
          });

          if (anyFixed) {
            updatedFixed[typeKey][chapId] = fixedMap;
            fixedEnabled[typeKey][chapId] = true;
          }
        });
      });
    });

    setCheckedChaptersByType((prev) => ({ ...prev, ...updatedChecked }));
    // setExpandedChaptersByType((prev) => ({ ...prev, ...updatedExpanded }));
    setSelectedTopicsByType((prev) => ({ ...prev, ...updatedTopics }));
    setFixedTopicCountsByType((prev) => ({ ...prev, ...updatedFixed }));
    setFixedTopicEnabledByType((prev) => ({ ...prev, ...fixedEnabled }));
  }, [draftData, topicData, data]);

  const previousErrorsRef = useRef([]);
  const handleValidate = () => {
    const currentErrors = [];

    // Recommended counts
    const recommendedEasy = activeSubject?.easy || 0;
    const recommendedMedium = activeSubject?.medium || 0;
    const recommendedTough = activeSubject?.tough || 0;

    const selectedEasy = difficultyCount.easy || 0;
    const selectedMedium = difficultyCount.medium || 0;
    const selectedTough = difficultyCount.tough || 0;

    const totalRecommended =
      recommendedEasy + recommendedMedium + recommendedTough;
    const totalSelected = selectedEasy + selectedMedium + selectedTough;

    if (totalRecommended !== totalSelected) {
      currentErrors.push(
        `Total recommended (${totalRecommended}) questions do not match selected questions (${totalSelected}).`
      );
    }

    if (recommendedEasy > 0 && selectedEasy !== recommendedEasy) {
      currentErrors.push(
        `Easy question count mismatch (Recommended: ${recommendedEasy}, Selected: ${selectedEasy}).`
      );
    }

    if (recommendedMedium > 0 && selectedMedium !== recommendedMedium) {
      currentErrors.push(
        `Medium question count mismatch (Recommended: ${recommendedMedium}, Selected: ${selectedMedium}).`
      );
    }

    if (recommendedTough > 0 && selectedTough !== recommendedTough) {
      currentErrors.push(
        `Tough question count mismatch (Recommended: ${recommendedTough}, Selected: ${selectedTough}).`
      );
    }

    const unassignedQuestions = selectedQuestions.filter(
      (q) => !q.section_name
    );
    if (unassignedQuestions.length > 0) {
      currentErrors.push(
        `${unassignedQuestions.length} question(s) do not have a section assigned.`
      );
    }

    if (selectedSections > 1) {
      for (let i = 0; i < selectedSections; i++) {
        const sectionLabel =
          selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i);
        const countInSection = sectionWiseQuestions[sectionLabel]?.length || 0;
        if (countInSection === 0) {
          currentErrors.push(
            `Section ${sectionLabel} has no questions selected.`
          );
        }
      }
    }

    if (selectedSections > 1) {
      for (let i = 0; i < selectedSections; i++) {
        const sectionLabel =
          selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i);
        const countInSection = sectionWiseQuestions[sectionLabel]?.length || 0;

        const sectionKey = `Section ${sectionLabel}`;
        const sectionData =
          sectionDetailsPerSubject?.[activeSubjectId]?.[sectionKey];
        const mandatoryCount = sectionData?.mandatory_ques_cnt || 0;
        const totalCount = sectionData?.total_ques_cnt || 0;

        if (countInSection === 0) {
          currentErrors.push(
            `Section ${sectionLabel} has no questions selected.`
          );
        }

        if (countInSection !== totalCount && totalCount > 0) {
          currentErrors.push(
            `Section ${sectionLabel}: Selected ${countInSection} of ${totalCount} questions. Mandatory count is ${mandatoryCount}.`
          );
        }
      }
    }

    Object.entries(fixedTopicEnabledByType).forEach(([type, chapters]) => {
      Object.entries(chapters).forEach(([chapId, isEnabled]) => {
        if (isEnabled) {
          const topics = fixedTopicCountsByType[type][chapId];
          Object.entries(topics).forEach(([topicId, fixedCount]) => {
            const actualCount = selectedQuestions.filter(
              (q) => q.topic_id === parseInt(topicId)
            ).length;
            if (actualCount !== fixedCount) {
              currentErrors.push(
                `Topic ${topicId} fixed count mismatch (Fixed: ${fixedCount}, Selected: ${actualCount}).`
              );
            }
          });
        }
      });
    });

    const chapterCounts = {};
    const topicCounts = {};

    selectedQuestions.forEach((q) => {
      chapterCounts[q.chapter_id] = (chapterCounts[q.chapter_id] || 0) + 1;
      topicCounts[q.topic_id] = (topicCounts[q.topic_id] || 0) + 1;
    });

    const totalChapterCount = Object.values(chapterCounts).reduce(
      (a, b) => a + b,
      0
    );
    const totalTopicCount = Object.values(topicCounts).reduce(
      (a, b) => a + b,
      0
    );

    if (totalChapterCount !== totalTopicCount) {
      currentErrors.push(
        `Total chapter count (${totalChapterCount}) does not match total topic count (${totalTopicCount}).`
      );
    }

    if (selectedSections > 0) {
      const localQuesTypeMap =
        JSON.parse(localStorage.getItem("subjectWiseQuesTypeIds") || "{}")[
          activeSubjectId
        ] || {};

      for (let i = 0; i < selectedSections; i++) {
        const sectionLabel =
          selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i);
        const sectionKey = `Section ${sectionLabel}`;
        const sectionData =
          sectionDetailsPerSubject?.[activeSubjectId]?.[sectionKey];
        const expectedTypeId = sectionData?.section_question_type_id;

        const questionsInSection = sectionWiseQuestions[sectionLabel] || [];
        // ✅ SKIP validation for Section A
        if (sectionLabel === "A") {
          continue;
        }

        if (!expectedTypeId) {
          currentErrors.push(
            `Section ${sectionLabel} has no question type assigned.`
          );
          continue;
        }

        const expectedTypeName =
          questionTypeMap[expectedTypeId] || `Type ID ${expectedTypeId}`;
        // const questionsInSection = sectionWiseQuestions[sectionLabel] || [];

        // Always show the expected type
        currentErrors.push(
          `Section ${sectionLabel} only allows "${expectedTypeName}" type questions.`
        );

        // Then optionally validate mismatch
        const hasMismatch = questionsInSection.some((q) => {
          const quesId = q.id || q.ques_id || q.parse_ques_set_question_id;
          const localType =
            parseInt(localQuesTypeMap[quesId]) ||
            q.ques_type_id ||
            q.ques_type ||
            q.question_type_id;
          return parseInt(localType) !== parseInt(expectedTypeId);
        });

        if (hasMismatch) {
          currentErrors.push(
            `⚠ Some questions in Section ${sectionLabel} have a different type. Please review.`
          );
        }
      }
    }

    // ✅ Compare with previous errors
    const unresolvedErrors = currentErrors.filter(
      (err) =>
        previousErrorsRef.current.includes(err) ||
        previousErrorsRef.current.length === 0
    );

    // ✅ Update previous errors for next validation
    previousErrorsRef.current = currentErrors;

    if (unresolvedErrors.length > 0) {
      setMessageBox(
        <div>
          {unresolvedErrors.map((err, idx) => (
            <p key={idx} style={{ margin: "4px 0" }}>
              {err}
            </p>
          ))}
        </div>
      );
      setMessageBoxHeight("auto");
    } else {
      setMessageBox(
        <div>
          <p> All validations passed successfully!</p>
        </div>
      );
      setMessageBoxHeight("10vh");
    }

    setActiveImg(WarnningIcon);
    setIsMessageBoxVisible(true);
  };

  const [questionOptions, setQuestionOptions] = useState({});
  const [showOptions, setShowOptions] = useState(false);

  const handlePreviewClick = async () => {
    const quesIds =
      JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}")[
        activeSubjectId
      ] || [];
    if (quesIds.length === 0) return;
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-ques-options-by-ques-id-list`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ques_id_list: quesIds }),
        }
      );

      if (response.ok) {
        const result = await response.json();

        // ✅ Transform response to { ques_id: [options] }
        const optionsMap = {};
        result.data?.questions?.forEach((q) => {
          optionsMap[q.ques_id] = q.ques_options || [];
        });

        setQuestionOptions(optionsMap);
        setShowPreviewPopup(true);
      } else {
        console.error("Failed to fetch options");
      }
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const allStatuses = accessibleSubjects
    .filter((subj) => subj.isAccessible)
    .map((subj, index, filteredList) => {
      const draftSubject = draftData?.subjects?.find(
        (s) => s.subject_id === subj.subject_id
      );
      const statusCode = draftSubject?.status;
      const statusText = statusMap[statusCode] || "Assigned";
      const isActive = subj.subject_id === activeSubjectId;

      return (
        <span key={subj.subject_id}>
          <span style={{ fontWeight: isActive ? "bold" : "normal" }}>
            {subj.subject_name} - {statusText}
          </span>
          {index !== filteredList.length - 1 && " | "}
        </span>
      );
    });

  // Add this new constant for showing ALL subjects with status
  const allSubjectsWithStatus = accessibleSubjects.map(
    (subj, index, allList) => {
      const draftSubject = draftData?.subjects?.find(
        (s) => s.subject_id === subj.subject_id
      );
      const statusCode = draftSubject?.status;
      const statusText = statusMap[statusCode] || "Assigned";
      const isActive = subj.subject_id === activeSubjectId;

      return (
        <span key={subj.subject_id}>
          <span
            style={{
              fontWeight: isActive ? "bold" : "normal",
              opacity: subj.isAccessible ? 1 : 0.6, // Make non-accessible subjects slightly faded
            }}
          >
            {subj.subject_name} - {statusText}
          </span>
          {index !== allList.length - 1 && " | "}
        </span>
      );
    }
  );

  useEffect(() => {
    // Clear section-wise questions when subject tab changes
    setSectionWiseQuestions({});
  }, [activeSubjectId]);

  const noOfSections = draftData?.subjects?.find(
    (s) => s.subject_id === activeSubjectId
  )?.no_of_sections;
  const sectionNamingPattern = draftData?.subjects?.find(
    (s) => s.subject_id === activeSubjectId
  )?.section_naming_pattern;
  const isFixedLayout =
    data?.ques_paper_details?.ques_paper_type === 2 &&
    noOfSections > 0 &&
    sectionNamingPattern !== null;

  const questionTypeMap = {
    1: "Single Select",
    2: "Multiple Select",
    3: "Boolean",
    4: "Fill-in the Blanks",
  };

  const hasInstructions = specialInstructions?.[activeSubjectId]?.trim();
  const hasMandatory = sectionDetailsPerSubject?.[activeSubjectId];

  const dynamicMarginTop =
    hasInstructions && hasMandatory
      ? "40px"
      : hasInstructions || hasMandatory
      ? "194px"
      : "234px";

  // Update the handleReviewAction function
  // const handleReviewAction = async (status, actionType) => {
  //   if (!questionPaperId || !activeSubjectId || !userId) {
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>Missing required data to perform this action.</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(ErrorIcon);
  //     setIsMessageBoxVisible(true);
  //     return;
  //   }

  //   // If no comment is provided, show error
  //   if (!reviewComment.trim()) {
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>
  //             Please provide review comments before {actionType.toLowerCase()}
  //             ing.
  //           </span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(ErrorIcon);
  //     setIsMessageBoxVisible(true);
  //     return;
  //   }

  //   // Combine main comment with question-specific comments
  //   const combineComments = () => {
  //     let combinedComment = reviewComment.trim();

  //     // Add question-specific comments if they exist
  //     const questionCommentEntries = Object.entries(questionComments).filter(
  //       ([_, comment]) => comment && comment.trim()
  //     );

  //     if (questionCommentEntries.length > 0) {
  //       combinedComment += " *H* ";
  //       questionCommentEntries.forEach(([questionId, comment]) => {
  //         combinedComment += `Question Id ${questionId}: ${comment.trim()} *H* `;
  //       });
  //     }

  //     return combinedComment;
  //   };

  //   try {
  //     const finalComment = combineComments();

  //     const response = await POST.withToken(
  //       EndPoints.CreateQuestionPaperReviewHistory,
  //       {
  //         ques_paper_id: parseInt(questionPaperId, 10),
  //         subject_id: activeSubjectId,
  //         reviewed_by_user_id: userId,
  //         reviewed_on: new Date().toISOString(),
  //         status: status,
  //         comments: finalComment,
  //       },
  //       {
  //         setMessageBox,
  //         setIsMessageBoxVisible,
  //         setActiveImg,
  //         ErrorImg: ErrorIcon,
  //       }
  //     );

  //     if (response?.status === 200) {
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>
  //               {response.message ||
  //                 `Question paper successfully ${actionType.toLowerCase()}.`}
  //             </span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(SuccessImg);

  //       // Reload after success
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 2000);
  //     }
  //   } catch (error) {
  //     console.error("Review action error:", error);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>
  //             {error.message ||
  //               `Failed to ${actionType.toLowerCase()} question paper.`}
  //           </span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(ErrorIcon);
  //   } finally {
  //     setIsMessageBoxVisible(true);
  //   }
  // };

  const handleReviewAction = async (status, actionType) => {
    if (!questionPaperId || !activeSubjectId || !userId) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Missing required data to perform this action.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
      setIsMessageBoxVisible(true);
      return;
    }

    // Only require main comment for REJECT action (status 4)
    // Updated validation logic for REJECT action
    if (status === 4) {
      // REJECT action
      const hasMainComment = reviewComment.trim();
      const hasQuestionComments = Object.values(questionComments).some(
        (comment) => comment && comment.trim()
      );

      // Only show error if NEITHER main comment NOR question-specific comments exist
      if (!hasMainComment && !hasQuestionComments) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <div>
                {" "}
                Please provide review comments before {actionType.toLowerCase()}
                ing.
              </div>
            </div>
          </div>
        );
        setActiveImg(ErrorIcon);
        setIsMessageBoxVisible(true);
        return;
      }
    }

    // For APPROVE, check if there's either a main comment OR question-specific comments
    if (status === 3) {
      const hasMainComment = reviewComment.trim();
      const hasQuestionComments = Object.values(questionComments).some(
        (comment) => comment && comment.trim()
      );
    }

    // Combine main comment with question-specific comments
    const combineComments = () => {
      let combinedComment = reviewComment.trim();

      // Add question-specific comments if they exist
      const questionCommentEntries = Object.entries(questionComments).filter(
        ([, comment]) => comment && comment.trim()
      );

      if (questionCommentEntries.length > 0) {
        if (combinedComment) {
          combinedComment += " *H* ";
        }
        questionCommentEntries.forEach(([questionId, comment]) => {
          combinedComment += `Question Id ${questionId}: ${comment.trim()} *H* `;
        });
      }

      return combinedComment;
    };

    try {
      const finalComment = combineComments();

      const response = await POST.withToken(
        EndPoints.CreateQuestionPaperReviewHistory,
        {
          ques_paper_id: parseInt(questionPaperId),
          subject_id: activeSubjectId,
          reviewed_by_user_id: userId,
          reviewed_on: new Date().toISOString(),
          status: status,
          comments: finalComment,
        },
        {
          setMessageBox,
          setIsMessageBoxVisible,
          setActiveImg,
          ErrorImg: ErrorIcon,
        }
      );

      if (response?.status === 200) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                {response.message ||
                  `Question paper successfully ${actionType.toLowerCase()}.`}
              </span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);

        // Reload after success
        setTimeout(() => window.location.reload(), 2000);
      }
    } catch (error) {
      console.error("Review action error:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              {error.message ||
                `Failed to ${actionType.toLowerCase()} question paper.`}
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
    } finally {
      setIsMessageBoxVisible(true);
    }
  };

  const parseComments = (commentString) => {
    if (!commentString) return { mainComment: "", questionComments: [] };

    const parts = commentString.split(" *H* ");
    const mainComment = parts[0].trim();
    const questionComments = [];

    for (let i = 1; i < parts.length; i++) {
      const part = parts[i].trim();
      if (part) {
        const match = part.match(/^Question Id (\d+): (.+)$/);
        if (match) {
          questionComments.push({
            questionId: match[1],
            comment: match[2],
          });
        }
      }
    }

    return { mainComment, questionComments };
  };

  // State to store section instructions for the table
  const [sectionInstructionsForTable, setSectionInstructionsForTable] =
    useState({});

  // Add useEffect to populate section instructions from draft data using activeSubjectId
  useEffect(() => {
    if (!draftData?.subjects || !activeSubjectId) {
      setSectionInstructionsForTable({});
      return;
    }

    const instructionsDataForTable = {};

    // Extract section instructions from the active subject using activeSubjectId
    const activeSubject = draftData.subjects.find(
      (subject) => subject.subject_id === activeSubjectId
    );

    // console.log("Active Subject Found:", activeSubject); // Debug line
    // console.log("Active Subject ID:", activeSubjectId); // Debug line

    if (activeSubject && activeSubject.sections) {
      activeSubject.sections.forEach((section) => {
        // Use correct field names from your data structure ✅
        const sectionName = section.section_name; // NOT section.sectionname
        const instruction = section.section_instruction; // NOT section.sectioninstruction

        // console.log(`Section ${sectionName}:`, instruction); // Debug line

        // Only add if instruction exists and is not null/empty
        if (instruction && instruction.trim()) {
          instructionsDataForTable[sectionName] = instruction.trim();
        }
      });
    }

    // console.log("Final Instructions Data:", instructionsDataForTable); // Debug line
    setSectionInstructionsForTable(instructionsDataForTable);
  }, [draftData, activeSubjectId]);

  // Debug the object structure
  // console.log(
  //   "Section Instructions Object:",
  //   JSON.stringify(sectionInstructionsForTable, null, 2)
  // );

  // Or log individual sections
  Object.entries(sectionInstructionsForTable).forEach(
    ([sectionName, instruction]) => {
      console.log(`Section ${sectionName}:`, instruction);
    }
  );

  // console.log(sectionInstructionsForTable + "sectionInstructionsForTable");
  return (
    <>
      <div className="sticky-header-container">
        <div className="Header-up">
          <span className="span-RQ" style={{ marginLeft: "10px" }}>
            Review Question Paper
            <span style={{ color: "lightgrey" }}></span>
          </span>
          <div style={{ marginRight: "30px" }}>
            <button
              className="testreportcard-cancel-btn"
              style={{ boxShadow: `0px 4px 4px 0px ${Colors.color11}` }}
              onClick={() => navigate(-1)}
            >
              CANCEL
            </button>
            <button
              className="testreportcard-cancel-btn"
              style={{ boxShadow: `0px 4px 4px 0px ${Colors.color11}` }}
              onClick={() => handleReviewAction(4, "Rejected")}
            >
              REJECT
            </button>
            <button
              className="testreportcard-create-btn "
              style={{ boxShadow: `0px 4px 4px 0px ${Colors.color11}` }}
              onClick={() => handleReviewAction(3, "Approved")}
            >
              APPROVE
            </button>
          </div>
        </div>
      </div>
      <div className="create-role-container">
        <div className="display-ques-paper-del">
          <div className="personal-header">
            <div className="header">
              {" "}
              <label>QUESTION PAPER DETAIL</label>{" "}
            </div>
            <div className="accordion-btn" onClick={toggleAccordionSubjects}>
              {" "}
              {isOpenSubject ? (
                <div className="minus"></div>
              ) : (
                <div className="plus">+</div>
              )}{" "}
            </div>
          </div>
          {isOpenSubject && (
            <div className="accordion-content">
              <div className="display-test-data-container-ques-paper-del">
                <div className="display-grid-container-ques-paper-del">
                  <div className="item1">
                    {" "}
                    <p>
                      {" "}
                      <span>Course:</span>{" "}
                      {data?.ques_paper_details?.course_name || "N/A"}{" "}
                    </p>{" "}
                  </div>
                  <div className="item2">
                    {" "}
                    <p>
                      {" "}
                      <span>Question Paper Type:</span>{" "}
                      {data?.ques_paper_details?.ques_paper_type_name || "N/A"}{" "}
                    </p>{" "}
                  </div>
                  <div className="item3">
                    {" "}
                    <p>
                      {" "}
                      <span>Test Series</span>{" "}
                      {data?.ques_paper_details?.test_series_name || "N/A"}{" "}
                    </p>{" "}
                  </div>
                  <div className="item5">
                    {" "}
                    <p>
                      {" "}
                      <span>Class:</span>{" "}
                      {data?.classes?.length > 0
                        ? data.classes.length === 1
                          ? data.classes[0].class_name
                          : data.classes.length === 2
                          ? `${data.classes[0].class_name}, ${data.classes[1].class_name}`
                          : "Multiple"
                        : "N/A"}{" "}
                    </p>{" "}
                  </div>
                  <div className="item6">
                    {" "}
                    <p>
                      {" "}
                      <span style={{ marginRight: "18px" }}>
                        Created By:
                      </span>{" "}
                      {data?.ques_paper_details?.created_by || "N/A"}{" "}
                    </p>{" "}
                  </div>
                  <div className="item4">
                    {" "}
                    <p>
                      {" "}
                      <span>Assigned On:</span>{" "}
                      {data?.ques_paper_details?.assigned_on || "N/A"}{" "}
                    </p>{" "}
                  </div>
                  <div className="item8">
                    {" "}
                    <p>
                      {" "}
                      <span>Question Paper:</span>{" "}
                      {data?.ques_paper_details?.ques_paper_name || "N/A"}{" "}
                    </p>{" "}
                  </div>
                  <div className="item9">
                    {" "}
                    <p>
                      {" "}
                      <span style={{ marginRight: "18px" }}>
                        Description:
                      </span>{" "}
                      {data?.ques_paper_details?.description || "N/A"}{" "}
                    </p>{" "}
                  </div>
                  <div className="item7">
                    {" "}
                    <p>
                      {" "}
                      <span>Due Date:</span>{" "}
                      {data?.ques_paper_details?.due_date || "N/A"}{" "}
                    </p>{" "}
                  </div>
                  <div className="item9">
                    {groupedScopes && Object.keys(groupedScopes).length > 0 ? (
                      Object.entries(groupedScopes).map(([scopeId, names]) => {
                        const label = scopeTypeMap[scopeId] || "Scope";
                        let displayValue = "";

                        if (names.length === 1) {
                          displayValue = names[0];
                        } else if (names.length === 2) {
                          displayValue = `${names[0]}, ${names[1]}`;
                        } else if (names.length > 2) {
                          displayValue = "Multiple";
                        }

                        if (!displayValue) {
                          displayValue = "N/A";
                        }

                        return (
                          <p key={scopeId}>
                            <span>{label}:</span> {displayValue}
                          </p>
                        );
                      })
                    ) : (
                      <p>
                        <span>Scope:</span> N/A
                      </p>
                    )}
                  </div>
                  <div className="item10-ques-paper-guideline">
                    {" "}
                    <p>
                      {" "}
                      <span style={{ marginRight: "18px" }}>
                        Guideline:
                      </span>{" "}
                      {data?.ques_paper_details?.guidelines || "N/A"}{" "}
                    </p>
                  </div>
                  <div className="item9-ques-paper-status">
                    <p>
                      {/* <span>Status:</span> {allStatuses} */}
                      <span>Status:</span> {allSubjectsWithStatus}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div style={{ marginTop: "20px" }}>
          {accessibleSubjects.length > 0 && (
            <TabComponent
              accessibleSubjects={accessibleSubjects}
              onTabChange={handleTabChange}
              hasUnsavedChanges={hasUnsavedChanges}
              activeSubjectId={activeSubjectId}
            />
          )}
          <div className="display-ques-paper-del-subjects">
            <div className="accordion-content">
              <div className="display-subjects-test-data-container-ques-paper-del">
                <div className="display-grid-container-ques-paper-subjects-del">
                  {specialInstructions?.[activeSubjectId]?.trim() !== "" && (
                    <div className="item1-subjects-details-content">
                      <img src={NotesIcon} alt="note icon" />
                      <p>{specialInstructions[activeSubjectId]}</p>
                    </div>
                  )}

                  {sectionDetailsPerSubject?.[activeSubjectId] && (
                    <div
                      className={
                        specialInstructions?.[activeSubjectId]?.trim()
                          ? "section-selection-details-subject"
                          : "section-selection-details-subject no-instructions"
                      }
                      style={{ marginLeft: "30px" }}
                    >
                      <div className="section-details-content-subject">
                        <p>Mandatory Questions:</p>
                        <ul
                          style={{
                            marginLeft: "20px",
                            marginTop: "12px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                            color: "#424242",
                            fontSize: "14px",
                          }}
                        >
                          {Object.entries(
                            sectionDetailsPerSubject[activeSubjectId]
                          ).map(([sectionName, details]) => {
                            const typeName =
                              questionTypeMap[
                                details.section_question_type_id
                              ] || "";
                            return (
                              <li key={sectionName}>
                                {sectionName} ({typeName}) -{" "}
                                {details.mandatory_ques_cnt}/
                                {details.total_ques_cnt}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  )}
                  <div
                    className="item3-subject-apply-template"
                    style={{ height: "0px", marginTop: dynamicMarginTop }}
                  >
                    <SectionSelectedDropdown
                      label="Apply Template"
                      selected={selectedTemplateId}
                      setSelected={(selectedOption) => {
                        setSelectedTemplateId(selectedOption || null);
                      }}
                      options={[
                        { id: "", label: "Select" },
                        ...templateData.map((template) => ({
                          id: template.id,
                          label: `${template.name} - ${template.description}`,
                        })),
                      ]}
                      Height="auto"
                      OverFlow="auto"
                      minheight="300px"
                      disabled={isActiveSubjectReadOnly()}
                    />
                  </div>
                  <div
                    className="item3-subject-apply-template"
                    style={{ height: "0px", marginTop: dynamicMarginTop }}
                  >
                    <ExcludeInput
                      label="Exclude Repeated Questions"
                      value={`${excludeRepeatCount} ${
                        excludeRepeatCount === 1 ? "time" : "times"
                      }`}
                      onChange={(e) => {
                        if (
                          isActiveSubjectReadOnly() ||
                          data?.ques_paper_details?.ques_paper_type === 1
                        )
                          return;
                        const val = e.target.value.replace(/[^\d]/g, "");
                        if (/^\d*$/.test(val)) {
                          const count = parseInt(val || 0, 10);
                          setExcludeRepeatCount(count);
                          setSectionSettingsBySubject((prev) => ({
                            ...prev,
                            [activeSubjectId]: {
                              ...(prev[activeSubjectId] || {}),
                              excludeRepeatCount: count,
                            },
                          }));
                          setExcludeRepeatEdited(true);
                        }
                      }}
                      disabled={
                        isActiveSubjectReadOnly() ||
                        data?.ques_paper_details?.ques_paper_type === 1
                      }
                    />
                  </div>

                  <div className="item5-subject-progress">
                    {/* Grouped progress bars */}
                    <div
                      className="progress-group"
                      style={
                        allRecommendedZero
                          ? { minHeight: "200px", opacity: 0.6 }
                          : {}
                      }
                    >
                      <div className="legend-container">
                        <div className="legend-item">
                          <span className="legend-box recommended"></span>
                          <span>Recommended</span>
                        </div>
                        <div className="legend-item">
                          <span className="legend-box-group">
                            <span className="legend-box present-green"></span>
                            <span className="legend-box present-yellow"></span>
                            <span className="legend-box present-red"></span>
                          </span>
                          <span>Present</span>
                        </div>
                      </div>
                      {/* Easy */}
                      <div className="progress-container">
                        <span className="progress-label">
                          {recommendedEasy}
                        </span>
                        <div
                          className="progress-bar"
                          style={{
                            height: `${easyBarHeight}px`,
                            display: "flex",
                            alignItems: "flex-end",
                          }}
                        >
                          <div
                            className="progress-fill"
                            style={{
                              height: `${easyFillHeight}px`,
                              backgroundColor: "#4A9D45",
                            }}
                          ></div>
                        </div>
                        <span
                          className="progress-value-outside-easy"
                          style={{
                            bottom: easyBottom,
                            color: "#4A9D45",
                            fontSize: "12px",
                            position: "absolute",
                          }}
                        >
                          {easyCount}{" "}
                        </span>
                        <span className="progress-title">Easy</span>
                      </div>
                      {/* Medium */}
                      <div className="progress-container">
                        <span className="progress-label">
                          {recommendedMedium}
                        </span>
                        <div
                          className="progress-bar"
                          style={{
                            height: `${mediumBarHeight}px`,
                            display: "flex",
                            alignItems: "flex-end",
                          }}
                        >
                          <div
                            className="progress-fill"
                            style={{
                              height: `${mediumFillHeight}px`,
                              backgroundColor: "#FFBD20",
                            }}
                          ></div>
                        </div>
                        <span
                          className="progress-value-outside-easy"
                          style={{
                            bottom: mediumBottom,
                            color: "#FFBD20",
                            fontSize: "12px",
                            position: "absolute",
                          }}
                        >
                          {mediumCount}
                        </span>
                        <span className="progress-title">Med.</span>
                      </div>
                      {/* tough */}
                      <div className="progress-container">
                        <span className="progress-label">
                          {recommendedTough}
                        </span>
                        <div
                          className="progress-bar"
                          style={{
                            height: `${toughBarHeight}px`,
                            display: "flex",
                            alignItems: "flex-end",
                          }}
                        >
                          <div
                            className="progress-fill"
                            style={{
                              height: `${toughFillHeight}px`,
                              backgroundColor: "#FA4741",
                            }}
                          ></div>
                        </div>
                        <span
                          className="progress-value-outside-easy"
                          style={{
                            bottom: toughBottom,
                            color: "#FA4741",
                            fontSize: "12px",
                            position: "absolute",
                          }}
                        >
                          {toughCount}
                        </span>
                        <span className="progress-title">Tough</span>
                      </div>
                    </div>
                    <div className="progress-container horizontal">
                      <span className="progress-title">
                        {activeSubject?.subject_name} Overall Progress(
                        {totaldiff}/{overallRecommendedCount})
                      </span>
                      <div
                        className="progress-bar horizontal"
                        style={{
                          width: "368px",
                          minWidth: "368px",
                          maxWidth: "368px",
                          position: "relative",
                          border: "1px solid #ccc",
                          backgroundColor: "#f1f1f1",
                          height: "20px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          className="progress-fill horizontal"
                          style={{
                            width: `${overallFillPercent}%`,
                            backgroundColor: "#337AB7",
                            height: "100%",
                            display: cappedOverallCount > 0 ? "flex" : "none",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ transform: "scale(1)" }}>
                <ThreePieChart
                  questionPaperId={questionPaperId}
                  userId={userId}
                  setMessageBox={setMessageBox}
                  setIsMessageBoxVisible={setIsMessageBoxVisible}
                  setActiveImg={setActiveImg}
                  ErrorImg={ErrorIcon}
                  activeSubjectId={activeSubjectId}
                  onReviewHistoryFetched={handleReviewHistoryFetched} // Pass callback function
                />
              </div>

              <div className="create-ques-paper-ques-selected-container-text">
                <span>SELECTED QUESTIONS</span>
              </div>
              <div className="create-ques-paper-ques-selected-container">
                <TableForCommentReviewQuestionPaper
                  selectedQuestions={selectedQuestions}
                  selectedHeaders={selectedHeaders}
                  selectedSections={selectedSections}
                  setSectionWiseQuestions={setSectionWiseQuestions}
                  selecteSectionTypeID={selecteSectionTypeID}
                  setIsMessageBoxVisible={setIsMessageBoxVisible}
                  setActiveImg={setActiveImg}
                  setMessageBox={setMessageBox}
                  allQuesList={reportDashboardData}
                  setSelectedQuestions={setSelectedQuestions}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  draftData={draftData}
                  isReadOnlyMode={isReadOnlyMode}
                  setDifficultyCount={setDifficultyCount}
                  activeSubjectId={activeSubjectId}
                  version={version}
                  setVersion={setVersion}
                  sectionWiseQuestions={sectionWiseQuestions}
                  // Add new props
                  onCommentClick={handleCommentClick}
                  questionComments={questionComments}
                  onEyeClick={handleEyeIconClick} // Add this new prop
                  reportDashboardData={reportDashboardData} // Pass this so handler can access question text
                  sectionInstructions={sectionInstructionsForTable}
                />
              </div>
              <ModalForReviewQuestionPaper
                isOpen={commentModalOpen}
                onClose={() => {
                  setCommentModalOpen(false);
                  setSelectedQuestionId(null);
                }}
                questionId={selectedQuestionId}
                existingComment={questionComments[selectedQuestionId]}
                onSave={handleSaveQuestionComment}
              />

              {showPreviewPopup && (
                <div className="popup-overlay-template-layout">
                  <div
                    className="popup-box-template-layout"
                    style={{
                      width: "60vw",
                      height: "80vh",
                      paddingRight: "10px",
                      color: "#424242",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* Fixed Header Section */}
                    <div
                      style={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#fff",
                        zIndex: 2,
                        paddingTop: "10px",
                        paddingBottom: "10px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <h3 style={{ margin: 0 }}>
                          Preview Selected Questions
                        </h3>
                        <span
                          style={{
                            cursor: "pointer",
                            fontSize: "20px",
                            fontWeight: "bold",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            color: "#666",
                          }}
                          onClick={() => setShowPreviewPopup(false)}
                          title="Close"
                        >
                          {" "}
                          ×{" "}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexWrap: "wrap",
                          marginBottom: "10px",
                          fontSize: "14px",
                          marginTop: "10px",
                        }}
                      >
                        {/* Left Column */}
                        <div style={{ flex: "0 0 48%" }}>
                          <p style={{ marginBottom: "8px" }}>
                            <span>Course:</span>{" "}
                            {data?.ques_paper_details?.course_name || "N/A"}
                          </p>
                          <p>
                            <span>Question Paper Type:</span>{" "}
                            {data?.ques_paper_details?.ques_paper_type_name ||
                              "N/A"}
                          </p>
                        </div>
                        {/* Right Column */}
                        <div style={{ flex: "0 0 48%" }}>
                          <p style={{ marginBottom: "8px" }}>
                            <span>Class:</span>{" "}
                            {data?.classes?.length > 0
                              ? data.classes.map((c) => c.class_name).join(", ")
                              : "N/A"}
                          </p>
                          <p>
                            <span>Question Paper:</span>{" "}
                            {data?.ques_paper_details?.ques_paper_name || "N/A"}
                          </p>
                        </div>
                        <div
                          style={{
                            flex: "0 0 100%",
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "-40px",
                          }}
                        >
                          <ToggleButton
                            label=""
                            setValues={(val) => setShowOptions(val === 1)}
                          />
                        </div>
                      </div>
                      <hr
                        style={{
                          borderTop: "1px solid #ccc",
                          marginBottom: "0",
                        }}
                      />
                    </div>

                    <div style={{ overflowY: "auto", padding: "10px" }}>
                      {Object.entries(sectionWiseQuestions)
                        .sort(([a], [b]) => a.localeCompare(b)) // Sorts sections alphabetically
                        .map(([sectionName, questions]) => (
                          <div
                            key={sectionName}
                            style={{ marginBottom: "20px" }}
                          >
                            <h4
                              style={{
                                marginBottom: "10px",
                                textAlign: "center",
                              }}
                            >
                              Section {sectionName}
                            </h4>
                            {questions.length > 0 ? (
                              <ul style={{ paddingLeft: "20px" }}>
                                {questions.map((ques, index) => {
                                  const quesId =
                                    ques.id || ques.parse_ques_set_question_id;
                                  const options = questionOptions[quesId] || [];

                                  return (
                                    <li
                                      key={quesId || index}
                                      style={{ marginBottom: "16px" }}
                                    >
                                      <div style={{ marginBottom: "4px" }}>
                                        {index + 1}. {ques.text}
                                        {/* <QuestionTextRenderer questionText={ques.text} /> */}
                                      </div>
                                      {showOptions && (
                                        <ul
                                          style={{
                                            paddingLeft: "20px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "20px",
                                              flexWrap: "wrap",
                                            }}
                                          >
                                            {[0, 1].map((col) => (
                                              <ul
                                                key={col}
                                                style={{
                                                  flex: "1 1 45%",
                                                  paddingLeft: "20px",
                                                  marginTop: "5px",
                                                  listStyleType: "disc",
                                                }}
                                              >
                                                {options
                                                  .filter(
                                                    (_, idx) => idx % 2 === col
                                                  )
                                                  .map((option, idx) => {
                                                    const globalIndex =
                                                      col + idx * 2;
                                                    return (
                                                      <li
                                                        key={
                                                          option.option_id ||
                                                          globalIndex
                                                        }
                                                        style={{
                                                          padding: "10px",
                                                        }}
                                                      >
                                                        {String.fromCharCode(
                                                          65 + globalIndex
                                                        ).toLowerCase()}
                                                        .
                                                        <QuestionTextRenderer
                                                          questionText={
                                                            option.option_text
                                                          }
                                                        />
                                                      </li>
                                                    );
                                                  })}
                                              </ul>
                                            ))}
                                          </div>
                                        </ul>
                                      )}
                                    </li>
                                  );
                                })}
                              </ul>
                            ) : (
                              <p>No questions in this section.</p>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* Single Question View Modal */}
          {questionViewModalOpen && (
            <div className="popup-overlay-template-layout">
              <div
                className="popup-box-template-layout"
                style={{
                  width: "70vw",
                  height: "auto",
                  padding: "20px",
                  color: `${Colors.color1}`,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                    // borderBottom: "1px solid #ccc",
                    paddingBottom: "10px",
                  }}
                >
                  <h3 style={{ margin: 0 }}>
                    Question Details - ID: {selectedViewQuestionId}
                  </h3>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: `${Colors.color1}`,
                    }}
                    onClick={() => {
                      setQuestionViewModalOpen(false);
                      setSelectedViewQuestionId(null);
                      setSelectedQuestionData(null);
                      setQuestionOptionsForView([]);
                      setSelectedQuestionText("");
                    }}
                    title="Close"
                  >
                    ×
                  </span>
                </div>

                {/* Question Content */}
                <div style={{ overflowY: "auto", flex: 1 }}>
                  {/* Question Text */}
                  <div style={{ marginBottom: "20px" }}>
                    <h4>Question:</h4>
                    <div
                      style={{
                        padding: "15px",
                        // backgroundColor: "#f8f9fa",
                        borderRadius: "5px",
                        marginBottom: "20px",
                        // border: "1px solid #ddd",
                        minHeight: "60px",
                      }}
                    >
                      {selectedQuestionText ? (
                        <QuestionTextRenderer
                          questionText={selectedQuestionText}
                        />
                      ) : (
                        <div
                          style={{
                            // color: "#666",
                            fontStyle: "italic",
                          }}
                        >
                          Loading question...
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Options */}
                  {questionOptionsForView &&
                    questionOptionsForView.length > 0 && (
                      <div>
                        <h4>Options:</h4>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                          }}
                        >
                          {questionOptionsForView.map((option, index) => (
                            <div
                              key={option.option_id || index}
                              style={{
                                padding: "15px",
                                // backgroundColor: "#fff",
                                // border: "1px solid #ddd",
                                borderRadius: "5px",
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "10px",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "bold",
                                  minWidth: "30px",
                                  // color: "#337AB7",
                                  fontSize: "16px",
                                }}
                              >
                                {String.fromCharCode(65 + index)}.
                              </span>
                              <div style={{ flex: 1 }}>
                                <QuestionTextRenderer
                                  questionText={option.option_text}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                  {/* Loading state for options */}
                  {questionOptionsForView.length === 0 &&
                    selectedQuestionText && (
                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#666",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "5px",
                          border: "1px solid #ddd",
                        }}
                      >
                        Loading options...
                      </div>
                    )}

                  {/* No options available */}
                  {questionOptionsForView.length === 0 &&
                    !selectedQuestionText && (
                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#666",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "5px",
                          border: "1px solid #ddd",
                        }}
                      >
                        No options available for this question.
                      </div>
                    )}
                </div>

                {/* Footer with question metadata */}
                {selectedQuestionData && (
                  <div
                    style={{
                      borderTop: "1px solid #ccc",
                      paddingTop: "15px",
                      marginTop: "10px",
                      fontSize: "14px",
                      color: "#666",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "20px",
                        flexWrap: "wrap",
                      }}
                    >
                      <span>
                        <strong>Question Type:</strong>{" "}
                        {selectedQuestionData.ques_type_id === 1
                          ? "Single Correct MCQ"
                          : selectedQuestionData.ques_type_id === 2
                          ? "Multi Correct MCQ"
                          : selectedQuestionData.ques_type_id === 3
                          ? "Fill in the blanks"
                          : selectedQuestionData.ques_type_id === 4
                          ? "True/False"
                          : "Unknown"}
                      </span>
                      {/* <span>
                        <strong>Total Options:</strong>{" "}
                        {questionOptionsForView.length}
                      </span> */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <SlideOutMessageBox
            onCommentChange={handleCommentChange}
            reviewHistory={reviewHistory} // Pass review history directly
            activeSubjectId={activeSubjectId}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "20px",
              gap: "20px",
            }}
          >
            <div className="create-ques-paper-ques-bank-preview-valiedate">
              <button onClick={handlePreviewClick}> Preview </button>{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReviewQuestionPaper;
